<template>
<div class="quote-fpc"
	:data-isparams="isParamsOk"
	:class="(relation === 'pcb' || stay === 'pcb')?'quote-box-wrap':'quote-nocheck'"
>
	<quote-relation v-if="0" :title="LANG.pcb_quote" name="pcb" @reset="reset">
		<!-- <a v-if="stay === 'pcb'" class="pcb-gerberview-link fc-main" target="_blank" href="/quote-gerber" slot="gt">
			<i class="icon f-bold mg-r-xs">&#xe64f;</i>
			{{LANG.online_gerber_viewer_pro}}
		</a> -->
	</quote-relation>
	<template v-if="relation === 'pcb' || stay === 'pcb' || stay === 'smt'">
		<!-- pcb gerberview -->
		<pcb-upgerberfile v-if="relation !== 'pcb' || stay === 'smt'" :pcbParams="params" @resolveGerberSuccess="resolveGerberSuccess" @resolveGerberFailed="resolveGerberFailed" @getfid="getfid"></pcb-upgerberfile>
		<!-- pcb gerberview end-->

		<!-- Basic Information -->
		<div class="title-bar" :style="{'margin-bottom': showPart[1] ? 0 : '10px'}" @click="handldeShowMore(1)">
			<h2>{{LANG.basic_info}}</h2>
			<a class="show-more">
				<svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="16" viewBox="0 0 16.027 16" class="icon-arrow" :class="roateMoreArrow(1)"><g transform="translate(-887 -1032)"><rect class="bg" width="16" height="16" transform="translate(887 1032)"/><path class="main" d="M376.125,206.754a.877.877,0,0,1,1.257,0,.92.92,0,0,1,0,1.282l-7.111,7.254a.877.877,0,0,1-1.258,0l-7.112-7.254a.92.92,0,0,1,0-1.282.877.877,0,0,1,1.257,0l6.483,6.613Z" transform="translate(525.384 828.993)"/></g></svg>
			</a>
		</div>

		<div v-show="showPart[1]" class="params-box">
			<np-collapse :title="LANG.basic_info">
				<!-- Material Type  -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							<span class="vlm">{{LANG.material_type}}</span> <i @mouseover="alertHelp($event,'readhelp_material')" @mouseleave="alertHelp($event,'readhelp_material')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items pcb-plate-type">
						<quote-check v-model="params.plate_type" :items="list.plate_type"  @click="plateTypeClick">
							<template v-slot:default="items">
								<img :src="$imgList[`plate_type_${items.item.value.keys}`]" width="28" style="margin-right:4px;">
							</template>
						</quote-check>
					</div>
				</div>
				<!-- ------------pcb Layer Count ----------- -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{isFpc? LANG.fpc_layer_count : LANG.layer_count}} <i @mouseover="alertHelp($event, isFpc ? 'readhelp_fpclayer count' : 'readhelp_layer count')" @mouseleave="alertHelp($event,isFpc ? 'readhelp_fpclayer count' : 'readhelp_layer count')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.blayer" :items="list.blayer">
							<router-link v-if="isFr4" to="/quote-by-sales" class="quotecheck quotecheck-radio" slot="end">
								<span class="quotecheck-text trans-animate">
									<span class="quotecheck-content"></span>
									<i class="vlm">22-32</i>
									<i @click.stop="(e)=>{e.preventDefault()}"
										@mouseover="alertHelp($event,'readhelp_tg')"
										@mouseleave="alertHelp($event,'readhelp_tg')"
										class="icon trans-animate vlm fs-xs quote-help vlm"
										style="margin-left: 2px;"
									>?</i>
								</span>
							</router-link>
						</quote-check>
						<p v-show="resolvedFileData.blayer && resolvedFileData.blayer != params.blayer" class="fc-quotetips pd-t-xs fs-sm">{{ LANG.resoleLANG('layers_diff_tip',{layer: resolvedFileData.initBlayer}) }}</p>
					</div>
				</div>
				<!-- Different Designs -->
				<div id="pbNum" class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							{{LANG.pbnum}} <i @mouseover="alertHelp($event,'pbnum_desc','500px')" @mouseleave="alertHelp($event,'pbnum_desc')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items pd-t-sm" >
						<div class="number-input-box">
							<div class="number-input-btn minus" :class="{'disable': diableMinusPbnum}" @click="clickMinusNumber">
								<!-- <img :src="$imgList.icon_minus"> -->—
							</div>
							<input v-model="params.pbnum" type="number" class="input-box" disabled/>
							<div class="number-input-btn plus" :class="{'disable': diablePlusPbnum}" @click="clickAddNumber">
								<!-- <img :src="$imgList.icon_plus"> -->+
							</div>
						</div>
						<span class="fc-dis fs-sm mg-l-sm">{{LANG.pbnum_must}}</span>
						<span class="fc-main fs-sm under-line mg-l-sm" @mouseover="showOrderKnow" @mouseleave="showOrderKnow">{{LANG.order_instructions}}</span>
						<p v-show="showPbnumLimitTip" class="fc-quotetips pd-t-xs fs-sm">{{LANG.pbnum_limit_tip}}</p>
					</div>
				</div>
				<!-- Size(single) -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							<span>{{LANG.size}}({{params.units===3 ? 'panel' :'single'}})<em class="fc-err pd-r-xs fs-md">*</em></span><i @mouseover="alertHelp($event,'readhelp_size')" @mouseleave="alertHelp($event,'readhelp_size')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div id="size" class="quote-box-items">					
						<np-input  width = "120px"   maxlength="5"  class="vlm" v-model="params.blength"  @input="inputSize($event,'blength')" :placeholder="LANG.length"
							:class="{'np-input_err':sizeCheck}"
						>
							<template slot="gt"></template>
						</np-input>
						<span class="vlm fs-sm mg-lg-sm"> X </span>
						<np-input maxlength="5" class="vlm" width = "120px" v-model="params.bwidth" @input="inputSize($event,'bwidth')" :placeholder="LANG.width"
							:class="{'np-input_err':sizeCheck}"
						>
							<em slot="gt" class="icon pd-lg-sm  fs-sm quote-input-units">
								mm
							</em>
						</np-input>
						<span @click="converSize" class="quote-size-conver vlm mg-l-md pd-lg-md fc-gnr" v-html="LANG.inch_mm">
						</span>
						<span @mouseover="sizeToggle" @mouseleave="sizeToggle"  class="fc-blue fs-sm vlm mg-l-md" v-text="LANG.case_display"></span>
						<p class="fc-quotetips pd-t-xs fs-sm">{{sizeTip}}</p>
					</div>
				</div>
				<!-- Quantity(single) -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							<span>{{LANG.qty}}({{params.units != 1 ? 'panel' :'single'}})<em class="fc-err pd-r-xs fs-md">*</em></span><i  @mouseover="alertHelp($event,'readhelp_quantity')" @mouseleave="alertHelp($event,'readhelp_quantity')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div id="qty" class="quote-box-items">
						<div class="quote-bcount" style="position: relative; z-index: 22;">
							<div v-if="this.isFr4" class="np-input vlm" style=" width: 180px;"
								:class="{'np-input_err':bcountCheck || showPcsTip}"							
							>
								<span class="np-input-table" @click.stop="showBcount">
									<em class="np-input-ct pd-l-sm" v-html="params.bcount||'&nbsp;'"></em>
									<i class="quote-input-units txt-ct" style="width: 40px;">
										{{params.units == 1?'pcs':'set'}}
									</i>
								</span>
							</div>
							<div v-else class="np-input vlm" style=" width: 180px;"
								:class="{'np-input_err':bcountCheck || showPcsTip}"							
							>
								<span class="np-input-table">
									<!-- <em class="np-input-ct pd-l-sm" v-html="params.bcount||'&nbsp;'"></em> -->
									<input type="text" v-model="params.bcount" class="pd-l-sm" @input="validateInput" />
									<i class="quote-input-units txt-ct" style="width: 40px;">
										{{params.units == 1?'pcs':'set'}}
									</i>
								</span>
							</div>
							<b v-if="pcscountShow" class="vlm f-bold fc-tips mg-l-md"> = {{pcscount}} pcs</b>
							<check-quantity type="pcb" top="34px" :area="getArea" :blayer="params.blayer" @change="bcountChange" v-model="bcountCheckShow" :realValue="params.bcount" :isFr4="isFr4" @numCheck="handlePcsCountCheck"></check-quantity>
						</div>
						<p v-show="showPcsTip" class="fc-quotetips pd-t-xs fs-sm">{{pcsCountTip}}</p>
						<p v-show="params.pbnum > 1" class="fc-quotetips pd-t-xs fs-sm">{{LANG.pbnum_pcs_tip}}</p>
					</div>
				</div>
				<!-- Board Type -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							{{LANG.board_type}} <i @mouseover="alertHelp($event,'readhelp_board type')" @mouseleave="alertHelp($event,'readhelp_board type')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.units" :items="list.unitsItem">
							<template v-slot:itemend="items">
								<i v-if="items.item.value.real != 1" @click.stop="(e)=>{e.preventDefault()}"
									@mouseover="alertHelp($event,items.item.value.realhelp)"
									@mouseleave="alertHelp($event,items.item.value.realhelp)"
									class="icon mg-l-xs trans-animate vlm fs-xs quote-help"
								>?</i>
							</template>
						</quote-check>
						<!-- <p v-if="params.units == 3" class="fc-quotetips pd-t-xs fs-sm" v-text="LANG.board_type_tips1"></p>
						<p v-if="params.units == 2" class="fc-quotetips pd-t-xs fs-sm" v-text="LANG.board_type_tips2"></p> -->
						<p v-show="resolvedFileData.oneOrMoreBoard == '多板' && params.units == 1" class="fc-quotetips pd-t-xs fs-sm">{{ LANG.imposition_diff_tip }}</p>
					</div>
				</div>
				<!-- Panel Type -->
				<div id="panelType" class="quote-box-line" v-if="params.units == 2 || params.units == 3">
					<div class="quote-box-tags" >
						<span class="t_text">
							<span>{{LANG.panel_type}}<em class="fc-err pd-r-xs fs-md">*</em></span>
						</span>
					</div>
					<div class="quote-box-items">
						<np-input  :width = "'120px'" type="number" class="vlm" v-model="params.layoutx" :placeholder="LANG.h_qty_placeholder" :class="{'np-input_err':layoutxCheck || paramsCheck.layoutErr}">
							<em slot="gt" class="icon pd-lg-sm fs-sm quote-input-units">
								pcs
							</em>
						</np-input>
						<span class="vlm fs-sm mg-lg-sm"> X </span>
						<np-input type="number" class="vlm" :width = "'120px'" v-model="params.layouty" :placeholder="LANG.v_qty_placeholder" :class="{'np-input_err':layoutyCheck || paramsCheck.layoutErr}">
							<em slot="gt" class="icon pd-lg-sm fs-sm  quote-input-units">
								pcs
							</em>
						</np-input>
						<span class="fc-main vlm mg-l-md fs-sm"  @mouseover="panelInfoToggle" @mouseleave="panelInfoToggle">
							{{LANG.panel_info}}
						</span>
						<p v-if="layoutxCheck || layoutyCheck" class="fc-quotetips pd-t-xs fs-sm">{{LANG.panel_type_tip1}}</p>
						<p v-if="!(layoutxCheck || layoutyCheck) && paramsCheck.layoutErr" class="fc-quotetips pd-t-xs fs-sm">{{LANG.panel_type_tip2}}</p>
					</div>
				</div>
				
				<!-- Break-away rail -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.break_away_rail}} <i  @mouseover="alertHelp($event,'readhelp_break-away rail')" @mouseleave="alertHelp($event,'readhelp_break-away rail')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div id="sideWidth" class="quote-box-items">
						<src-select @input="sidewidthCount" style="width: 182px;" class="vlm"  v-model="params.sidedirection" :items="list.sidedirectionItem"></src-select>
						<np-input ref="sidewidth" maxlength="2" v-if="params.sidedirection && params.sidedirection !== 'N/A'"  type="number" v-model="params.sidewidth" :width="'80px'" class="vlm" :class="{'np-input_err': paramsCheck.sidewidthErr}" style="margin-left: 2px;">
							<em slot="gt"  class="icon pd-lg-sm fs-sm quote-input-units">
								mm
							</em>
						</np-input>
						<p v-if="stay == 'smt' && params.sidedirection == 'N/A'" class="fc-quotetips pd-t-xs fs-sm">{{LANG.paba_breakaway_tip}}</p>
						<p v-if="paramsCheck.sidewidthErr" class="fc-quotetips pd-t-xs fs-sm">{{LANG.minimum_size}}</p>
					</div>
				</div>
			</np-collapse>
		</div>
		<!-- Basic Information end -->

		<!-- PCB Parameters -->
		<div class="title-bar" :style="{'margin-bottom': showPart[2] ? 0 : '10px'}" @click="handldeShowMore(2)">
			<h2>{{LANG.pcb_parameters}}</h2>
			<a class="show-more">
				<svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="16" viewBox="0 0 16.027 16" class="icon-arrow" :class="roateMoreArrow(2)"><g transform="translate(-887 -1032)"><rect class="bg" width="16" height="16" transform="translate(887 1032)"/><path class="main" d="M376.125,206.754a.877.877,0,0,1,1.257,0,.92.92,0,0,1,0,1.282l-7.111,7.254a.877.877,0,0,1-1.258,0l-7.112-7.254a.92.92,0,0,1,0-1.282.877.877,0,0,1,1.257,0l6.483,6.613Z" transform="translate(525.384 828.993)"/></g></svg>
			</a>
		</div>
		<div v-show="showPart[2]" class="params-box">
			<np-collapse>
				<template v-if="!isFpc && !isRfpc">
					<!-- ------------ Thermal Conductivity----------- -->
					<div class="quote-box-line" v-show="thermalcShow">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.thermal_conductivity}} <i @mouseover="alertHelp($event,'readhelp_thermal conductivity')" @mouseleave="alertHelp($event,'readhelp_thermal conductivity')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.thermalc" :items="list.thermalc"></quote-check>
						</div>
					</div>

					<!-- ------------ rogers ----------- -->
					<div class="quote-box-line" v-if="isRogers">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.rogers}} <i @mouseover="alertHelp($event,'readhelp_rogers')" @mouseleave="alertHelp($event,'readhelp_rogers')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.rogers" :items="list.rogers"></quote-check>
						</div>
					</div>
					
					<!-- ------------ TG board_tg----------- -->
					<div class="quote-box-line" v-show="TGshow">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.tg}} <i @mouseover="alertHelp($event,'readhelp_tg')" @mouseleave="alertHelp($event,'readhelp_tg')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.board_tg" :items="list.board_tg" @click="paramClick('board_tg')"></quote-check>
						</div>
					</div>
					<!-- ------------------PCB Thickness----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.pcb_thickness}}
							<i @mouseover="alertHelp($event,'readhelp_pcb thickness')" @mouseleave="alertHelp($event,'readhelp_pcb thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.bheight" :items="list.bheight" @click="paramClick('bheight')"></quote-check>
						</div>
					</div>
					<!-- ------------------Solder Mask Color----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.solder_mask_color}}
							<i @mouseover="alertHelp($event,'readhelp_solder mask color')" @mouseleave="alertHelp($event,'readhelp_solder mask color')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.color" :items="list.color">
								<template v-slot:default="items">
									<i :class="'quote-fpccolor-'+items.item.value.css"></i>
								</template>
							</quote-check>
						</div>
					</div>
					<!--Silkscreen -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.silkscreen}} <i @mouseover="alertHelp($event,'readhelp_silkscreen')" @mouseleave="alertHelp($event,'readhelp_silkscreen')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.charcolor" :items="list.charcolor">
								<template v-slot:default="items">
									<i :class="'quote-fpccolor-'+items.item.value.word"></i>
								</template>
							</quote-check>
						</div>
					</div>
					<!-- Outer Copper Weight -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							<span v-html="LANG.finished_copper_weight"></span> <i @mouseover="alertHelp($event,'readhelp_finished copper weight')" @mouseleave="alertHelp($event,'readhelp_finished copper weight')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.copper" :items="list.copper" @click="paramClick('copper')"></quote-check>
							<!-- <p v-show="params.copper>=2 || params.impendance === 1" class="fc-quotetips pd-t-xs fs-sm">{{LANG.insidecopper_tips}} </p> -->
						</div>
					</div>
					<!-- Inner Copper Weight -->
					<div class="quote-box-line" v-show="insidecopperShow">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.inner_copper_weight}} <i @mouseover="alertHelp($event,'readhelp_inner copper weight')" @mouseleave="alertHelp($event,'readhelp_inner copper weight')"  class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.insidecopper" :items="list.insidecopper" @change="insidecopperChange" @click="paramClick('insidecopper')"></quote-check>
						</div>
					</div>
				</template>
				<!-- Trace Width/Spacing -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						<span>{{LANG.min_trace_space_outer1}}</span> <i @mouseover="alertHelp($event,'readhelp_min. trace / space outer')" @mouseleave="alertHelp($event,'readhelp_min. trace / space outer')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.lineweight" :items="list.lineweight"></quote-check>
						<p v-show="resolvedFileData.lineweightReal && resolvedFileData.lineweightReal != (params.lineweight+'/'+params.lineweight)" class="fc-quotetips pd-t-xs fs-sm">{{ LANG.resoleLANG('min_drill_diff_tip',{mindrill: `${resolvedFileData.lineweightReal}mil`}) }}</p>
						<p v-if="showLineweightTip" class="fc-quotetips pd-t-xs fs-sm">{{ LANG.resoleLANG('lineweight_tip') }}</p>
					</div>
				</div>
				<!-- Min. Drill Hole -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.min_drilled_hole}} <i @mouseover="alertHelp($event,'readhelp_min. drilled hole')" @mouseleave="alertHelp($event,'readhelp_min. drilled hole')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.vias" :items="list.vias"></quote-check>
						<p v-show="resolvedFileData.initVias && resolvedFileData.initVias != params.vias" class="fc-quotetips pd-t-xs fs-sm">{{ LANG.resoleLANG('min_drill_diff_tip',{mindrill: resolvedFileData.initVias+'mm'}) }}</p>
					</div>
				</div>
				<!-- Via Processing -->
				<div v-if="isFr4 || isRfpc || isRogers" class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.via_process}} <i @mouseover="alertHelp($event,'readhelp_via process','420px')" @mouseleave="alertHelp($event,'readhelp_via process','420px')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.cover" :items="list.cover">
							<template v-slot:itemend="items">
								<i  @click.stop="(e)=>{e.preventDefault()}"
									@mouseover="alertHelp($event,items.item.value.realhelp)"
									@mouseleave="alertHelp($event,items.item.value.realhelp)"
									class="icon mg-l-xs trans-animate vlm fs-xs quote-help"
								>?</i>
							</template>
						</quote-check>
						<p v-show="showViaProcessTip" class="fc-quotetips pd-t-xs fs-sm">{{LANG.via_process_diff_tip}} </p>
					</div>
				</div>
				<!--- Surface Finish - - -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.surface_finish}} <i @mouseover="alertHelp($event,'readhelp_surface finish')" @mouseleave="alertHelp($event,'readhelp_surface finish')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.spray" :items="list.spray"></quote-check>
					</div>
				</div>
				<!-- ENIG Gold Thickness -->
				<div class="quote-box-line" v-show="cjhShow">
					<div class="quote-box-tags">
						<span class="t_text">
							<span v-html="LANG.thickness_of_immersion_gold"></span> <i @mouseover="alertHelp($event,'readhelp_surface finish')" @mouseleave="alertHelp($event,'readhelp_surface finish')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.cjh" :items="list.cjh"></quote-check>
					</div>
				</div>
				<!-- ENIG Gold Thickness -->
				<div class="quote-box-line" v-show="djhShow">
					<div class="quote-box-tags">
						<span class="t_text">
							<span v-html="LANG.djh"></span> <i @mouseover="alertHelp($event,'readhelp_surface finish')" @mouseleave="alertHelp($event,'readhelp_surface finish')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.electrogilding_thickness" :items="list.cjh"></quote-check>
					</div>
				</div>
			</np-collapse>
		</div>
		<!-- PCB Parameters end -->

		<!-- 硬板参数 -->
		<template v-if="isRfpc">
			<div class="title-bar" :style="{'margin-bottom': showPart[6] ? 0 : '10px'}" @click="handldeShowMore(6)">
				<h2>Rigid Parameters</h2>
				<a class="show-more">
					<svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="16" viewBox="0 0 16.027 16" class="icon-arrow" :class="roateMoreArrow(2)"><g transform="translate(-887 -1032)"><rect class="bg" width="16" height="16" transform="translate(887 1032)"/><path class="main" d="M376.125,206.754a.877.877,0,0,1,1.257,0,.92.92,0,0,1,0,1.282l-7.111,7.254a.877.877,0,0,1-1.258,0l-7.112-7.254a.92.92,0,0,1,0-1.282.877.877,0,0,1,1.257,0l6.483,6.613Z" transform="translate(525.384 828.993)"/></g></svg>
				</a>
			</div>
			<div v-show="showPart[6]" class="params-box">
				<np-collapse>
					<!-- ------------ TG board_tg----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.tg}} <i @mouseover="alertHelp($event,'readhelp_tg')" @mouseleave="alertHelp($event,'readhelp_tg')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.board_tg" :items="list.board_tg" @click="paramClick('board_tg')"></quote-check>
						</div>
					</div>
					<!-- ------------------PCB Thickness----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.pcb_thickness}}
							<i @mouseover="alertHelp($event,'readhelp_pcb thickness')" @mouseleave="alertHelp($event,'readhelp_pcb thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.bheight" :items="list.bheight" @click="paramClick('bheight')"></quote-check>
						</div>
					</div>
					<!-- ------------------Solder Mask Color----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.solder_mask_color}}
							<i @mouseover="alertHelp($event,'readhelp_solder mask color')" @mouseleave="alertHelp($event,'readhelp_solder mask color')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.color" :items="list.color">
								<template v-slot:default="items">
									<i :class="'quote-fpccolor-'+items.item.value.css"></i>
								</template>
							</quote-check>
						</div>
					</div>
					<!--Silkscreen -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.silkscreen}} <i @mouseover="alertHelp($event,'readhelp_silkscreen')" @mouseleave="alertHelp($event,'readhelp_silkscreen')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.charcolor" :items="list.charcolor">
								<template v-slot:default="items">
									<i :class="'quote-fpccolor-'+items.item.value.css"></i>
								</template>
							</quote-check>
						</div>
					</div>
					<!-- Outer Copper Weight -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							<span v-html="LANG.finished_copper_weight"></span> <i @mouseover="alertHelp($event,'readhelp_finished copper weight')" @mouseleave="alertHelp($event,'readhelp_finished copper weight')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.copper" :items="list.copper" @click="paramClick('copper')"></quote-check>
							<!-- <p v-show="params.copper>=2 || params.impendance === 1" class="fc-quotetips pd-t-xs fs-sm">{{LANG.insidecopper_tips}} </p> -->
						</div>
					</div>
					<!-- Inner Copper Weight -->
					<div class="quote-box-line" v-show="insidecopperShow">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.inner_copper_weight}} <i @mouseover="alertHelp($event,'readhelp_inner copper weight')" @mouseleave="alertHelp($event,'readhelp_inner copper weight')"  class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.insidecopper" :items="list.insidecopper" @change="insidecopperChange" @click="paramClick('insidecopper')"></quote-check>
						</div>
					</div>
				</np-collapse>
			</div>
		</template>
		<!-- 硬板参数 end -->

		<!-- FPC Parameters bgn -->
		<template v-if="isFpc || isRfpc">
		<div class="title-bar" :style="{'margin-bottom': showPart[5] ? 0 : '10px'}" @click="handldeShowMore(5)">
			<h2>{{LANG.fpc_parameters}}</h2>
			<a class="show-more">
				<svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="16" viewBox="0 0 16.027 16" class="icon-arrow" :class="roateMoreArrow(5)"><g transform="translate(-887 -1032)"><rect class="bg" width="16" height="16" transform="translate(887 1032)"/><path class="main" d="M376.125,206.754a.877.877,0,0,1,1.257,0,.92.92,0,0,1,0,1.282l-7.111,7.254a.877.877,0,0,1-1.258,0l-7.112-7.254a.92.92,0,0,1,0-1.282.877.877,0,0,1,1.257,0l6.483,6.613Z" transform="translate(525.384 828.993)"/></g></svg>
			</a>
		</div>
		<div v-show="showPart[5]" class="params-box">
			<np-collapse>
				<!-- ------------fpc Layer Count ----------- -->
				<div v-if="isRfpc" class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.fpc_layer_count}} <i @mouseover="alertHelp($event, 'readhelp_fpclayer count')" @mouseleave="alertHelp($event,'readhelp_fpclayer count')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_blayer" :items="list.fpcLayer"></quote-check>
					</div>
				</div>
				<!-- ------------ FPC Thickness----------- -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							{{LANG.fpc_thickness}} <i @mouseover="alertHelp($event,'readhelp_fpc_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_thickness" :items="fpcList.fpc_thickness" @click="paramClick('fpc_thickness')"></quote-check>
					</div>
				</div>
				
				<!-- ------------ Covering Type----------- -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							{{LANG.fpc_cover}} <i @mouseover="alertHelp($event,'readhelp_fpc_cover')" @mouseleave="alertHelp($event,'readhelp_fpc_cover')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_cover" :items="fpcList.fpc_cover"></quote-check>
					</div>
				</div>
				<!-- ------------------FPC Solder Mask Color----------- -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.fpc_solder_mask_color}}
						<i @mouseover="alertHelp($event,'readhelp_fpc_color')" @mouseleave="alertHelp($event,'readhelp_fpc_color')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_color" :items="fpcList.fpc_color">
							<template v-slot:default="items">
								<i :class="'quote-fpccolor-'+items.item.value.css"></i>
							</template>
						</quote-check>
					</div>
				</div>
				<!--FPC Silkscreen -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.fpc_silkscreen}} <i @mouseover="alertHelp($event,'readhelp_fpc_charcolor')" @mouseleave="alertHelp($event,'readhelp_fpc_charcolor')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_charcolor" :items="fpcList.fpc_charcolor">
							<template v-slot:default="items">
								<i :class="'quote-fpccolor-'+items.item.value.css"></i>
							</template>
						</quote-check>
					</div>
				</div>
				<!--FPC Material -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.fpc_material}} <i @mouseover="alertHelp($event,'readhelp_fpc_material','300px')" @mouseleave="alertHelp($event,'readhelp_fpc_material')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_material" :items="fpcList.fpc_material">
							<template v-slot:default="items">
								<i :class="'quote-fpccolor-'+items.item.value.word"></i>
							</template>
						</quote-check>
					</div>
				</div>
				<!--FPC PI Thickness -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.fpc_pi_thickness}} <i @mouseover="alertHelp($event,'readhelp_fpc_pi_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_pi_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_pi_thickness" :items="fpcList.fpc_pi_thickness">
							<template v-slot:default="items">
								<i :class="'quote-fpccolor-'+items.item.value.word"></i>
							</template>
						</quote-check>
					</div>
				</div>
				<!-- FPC Finished Copper Weight -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						<span v-html="LANG.fpc_finished_copper"></span> <i @mouseover="alertHelp($event,'readhelp_fpc_outsidecopper')" @mouseleave="alertHelp($event,'readhelp_fpc_outsidecopper')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_outsidecopper" :items="fpcList.fpc_outsidecopper"></quote-check>
						<!-- <p v-show="params.copper>=2 || params.impendance === 1" class="fc-quotetips pd-t-xs fs-sm">{{LANG.insidecopper_tips}} </p> -->
					</div>
				</div>
				<!-- FPC Inner Copper Weight -->
				<div class="quote-box-line" v-show="fpcInsideCopperShow">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.fpc_inner_copper}} <i @mouseover="alertHelp($event,'readhelp_fpc_insidecopper')" @mouseleave="alertHelp($event,'readhelp_fpc_insidecopper')"  class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.fpc_insidecopper" :items="fpcList.fpc_insidecopper"></quote-check>
					</div>
				</div>

				<!-- FPC -->
				<template v-if="isRfpc">
					<!-- ------------ Forming Method----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.forming_method}} <i @mouseover="alertHelp($event,'readhelp_fpc_forming_method')" @mouseleave="alertHelp($event,'readhelp_fpc_forming_method')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="fpc_forming_method" :items="fpcList.fpc_forming"></quote-check>
						</div>
					</div>
					<!-- ------------ Mold Forming----------- -->
					<div v-if="fpcMoldFormingShow" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.moulding}} <i @mouseover="alertHelp($event,'readhelp_fpc_mold_forming')" @mouseleave="alertHelp($event,'readhelp_fpc_mold_forming')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.fpc_forming" :items="fpcList.fpc_forming1"></quote-check>
						</div>
					</div>
					<!-- ------------ Stiffener Type----------- -->
					<div class="quote-box-line" ref="quote_ulmark">
						<div class="quote-box-tags">
							<span class="t_text">{{`Stiffener Type`}}<i @mouseover="alertHelp($event,'readhelp_fpc_stiffener', '600px')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener', '600px')" class="icon trans-animate vlm fs-xs quote-help">?</i></span> 
						</div>
						<div class="quote-box-items">
							<div style="display:flex;">
								<quote-check v-model="not_check_fpc_stiffener" :items="list.not_check_report"></quote-check>
								&nbsp;&nbsp;
								<quote-check v-model="fpc_stiffener" :items="fpcList.fpc_stiffener">
								</quote-check>
							</div>
						</div>
					</div>
					<!-- ------------ Stiffener Qty----------- -->
					<div v-if="fpc_stiffener.length" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`Stiffener Qty`}}
							</span>
						</div>
						<div class="quote-box-items">
							<np-input class="vlm" type="text" v-model="params.reinforce_num" width="160px" :maxlength="25" @input="handleInputReinforceNum">
								<template slot="gt"></template>
							</np-input>
						</div>
					</div>
					<!-- ------------ Stainless Steel Stiffener Thickness----------- -->
					<div v-if="fpc_stiffener.includes('reinforce_steel')" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{ `Stainless Steel Stiffener Thickness` }} <i @mouseover="alertHelp($event,'readhelp_fpc_stiffener_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.steel_thickness" :items="fpcList.steel_thickness"></quote-check>
						</div>
					</div>
					<!-- ------------ Aluminum Stiffener Thickness----------- -->
					<div v-if="fpc_stiffener.includes('reinforce_aluminium')" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`Aluminum Stiffener Thickness`}} <i @mouseover="alertHelp($event,'readhelp_fpc_stiffener_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.aluminium_thickness" :items="fpcList.aluminium_thickness"></quote-check>
						</div>
					</div>
					<!-- ------------ FR4 Stiffener Thickness----------- -->
					<div v-if="fpc_stiffener.includes('reinforce_fr4')" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`FR4 Stiffener Thickness`}} <i @mouseover="alertHelp($event,'readhelp_fpc_stiffener_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.fr4_thickness" :items="fpcList.fr4_thickness"></quote-check>
						</div>
					</div>
					<!-- ------------ PI Stiffener Thickness----------- -->
					<div v-if="fpc_stiffener.includes('reinforce_pi')" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`PI Stiffener Thickness`}} <i @mouseover="alertHelp($event,'readhelp_fpc_stiffener_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.pi_thickness" :items="fpcList.pi_thickness"></quote-check>
						</div>
					</div>
					<!-- ------------ Adhesive Backing----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`Adhesive Backing`}} <i @mouseover="alertHelp($event,'readhelp_fpc_tape')" @mouseleave="alertHelp($event,'readhelp_fpc_tape')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.tape" :items="fpcList.tape"></quote-check>
						</div>
					</div>
					<!-- ------------ EMI Shielding Film----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`EMI Shielding Film`}} <i @mouseover="alertHelp($event,'readhelp_fpc_emi')" @mouseleave="alertHelp($event,'readhelp_fpc_emi')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.emi" :items="fpcList.emi"></quote-check>
						</div>
					</div>
				</template>
			
			</np-collapse>
		</div>
		</template>
		<!-- FPC Parameters end -->

		<!-- Special Process -->
		<div class="title-bar" :style="{'margin-bottom': showPart[3] ? 0 : '10px'}" @click="handldeShowMore(3)">
			<h2>{{LANG.special_process}}</h2>
			<a class="show-more">
				<svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="16" viewBox="0 0 16.027 16" class="icon-arrow" :class="roateMoreArrow(3)"><g transform="translate(-887 -1032)"><rect class="bg" width="16" height="16" transform="translate(887 1032)"/><path class="main" d="M376.125,206.754a.877.877,0,0,1,1.257,0,.92.92,0,0,1,0,1.282l-7.111,7.254a.877.877,0,0,1-1.258,0l-7.112-7.254a.92.92,0,0,1,0-1.282.877.877,0,0,1,1.257,0l6.483,6.613Z" transform="translate(525.384 828.993)"/></g></svg>
			</a>
		</div>
		<div v-show="showPart[3]" class="params-box">
			<np-collapse>
				<!-- Fr-4 -->
				<template v-if="isFr4 || isRogers"> 
					<!-- ------------ Blind/Buried Vias----------- -->
					<div v-if="hasBlindShow" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG['hdi(buried/blind vias)']}} <i @mouseover="alertHelp($event,'readhelp_hdi buried/blind vias')" @mouseleave="alertHelp($event,'readhelp_hdi buried/blind vias')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="blind" :items="list.yes_no"></quote-check>
						</div>
					</div>
					<!--- HDI 阶数 HDI Structure - - -->
					<div class="quote-box-line" v-if="blindShow">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.hdi_structure}} <i @mouseover="alertHelp($event,'readhelp_rank structure')" @mouseleave="alertHelp($event,'readhelp_rank structure')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.blind" :items="list.blind"></quote-check>
						</div>
					</div>
					<!-- ------------ Impedance Control----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.impedance}}<i @mouseover="alertHelp($event,'readhelp_impedance')" @mouseleave="alertHelp($event,'readhelp_impedance')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<div class="flex-cell">
								<quote-check v-model="params.impendance" :items="list.yes_no"></quote-check>
								<a v-if="showRecommendStackup" class="fc-blue a_hover mg-l-sm" @click="openStackupDialog">
									Stackup Calculator
								</a>
							</div>	
						</div>
					</div>
					<!-- ------------ Edge Connector Bevel----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.beveling_of_g_f}} <i @mouseover="alertHelp($event,'readhelp_beveling of g/f')" @mouseleave="alertHelp($event,'readhelp_beveling of g/f')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.beveledge" :items="list.yes_no"></quote-check>
						</div>
					</div>
					<!-- ------------ Plated Half-holes----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.plated_half_holes}} <i @mouseover="alertHelp($event,'readhelp_plated half-holes')" @mouseleave="alertHelp($event,'readhelp_plated half-holes')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.bankong" :items="list.yes_no1"></quote-check>
							<p v-show="resolvedFileData.bankong == '1' && params.bankong == ''" class="fc-quotetips pd-t-xs fs-sm">File parsing has Plated Half-holes</p>
						</div>
					</div>
					<!-- ------------ Edge Plating----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.edge_plating}} <i @mouseover="alertHelp($event,'readhelp_plated half-holes')" @mouseleave="alertHelp($event,'readhelp_plated half-holes')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.baobian" :items="list.yes_no1"></quote-check>
						</div>
					</div>
					<!-- Stack up -->
					<div class="quote-box-line" v-show="pressingShow">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.laminated_structure}} <i @mouseover="alertHelp($event,'readhelp_laminated_structure')" @mouseleave="alertHelp($event,'readhelp_laminated_structure')"  class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.pressing" :items="list.pressing"></quote-check>
							<a v-if="showRecommendStackup" class="fc-blue a_hover vlm" @click="openStackupDialog">
								Stackup Calculator
							</a>
						</div>
					</div>
				</template>
				<!-- 铝基板、铜基板 -->
				<template v-if="isAluminum || isCopper">
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG['through-hole']}} 
							<!-- <i @mouseover="alertHelp($event,'readhelp_plated half-holes')" @mouseleave="alertHelp($event,'readhelp_plated half-holes')" class="icon trans-animate vlm fs-xs quote-help">?</i> -->
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.plug_in_holes" :items="list.plug_in_holes"></quote-check>
						</div>
					</div>
				</template>

				<!-- FPC -->
				<template v-if="isFpc">
					<!-- ------------ Forming Method----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.forming_method}} <i @mouseover="alertHelp($event,'readhelp_fpc_forming_method')" @mouseleave="alertHelp($event,'readhelp_fpc_forming_method')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="fpc_forming_method" :items="fpcList.fpc_forming"></quote-check>
						</div>
					</div>
					<!-- ------------ Mold Forming----------- -->
					<div v-if="fpcMoldFormingShow" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{LANG.moulding}} <i @mouseover="alertHelp($event,'readhelp_fpc_mold_forming')" @mouseleave="alertHelp($event,'readhelp_fpc_mold_forming')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.fpc_forming" :items="fpcList.fpc_forming1"></quote-check>
						</div>
					</div>
					<!-- ------------ Stiffener Type----------- -->
					<div class="quote-box-line" ref="quote_ulmark">
						<div class="quote-box-tags">
							<span class="t_text">{{`Stiffener Type`}}<i @mouseover="alertHelp($event,'readhelp_fpc_stiffener', '600px')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener', '600px')" class="icon trans-animate vlm fs-xs quote-help">?</i></span> 
						</div>
						<div class="quote-box-items">
							<div style="display:flex;">
								<quote-check v-model="not_check_fpc_stiffener" :items="list.not_check_report"></quote-check>
								&nbsp;&nbsp;
								<quote-check v-model="fpc_stiffener" :items="fpcList.fpc_stiffener">
								</quote-check>
							</div>
						</div>
					</div>
					<!-- ------------ Stiffener Qty----------- -->
					<div v-if="fpc_stiffener.length" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`Stiffener Qty`}}
							</span>
						</div>
						<div class="quote-box-items">
							<np-input class="vlm" type="text" v-model="params.reinforce_num" width="160px" :maxlength="25" @input="handleInputReinforceNum">
								<template slot="gt"></template>
							</np-input>
						</div>
					</div>
					<!-- ------------ Stainless Steel Stiffener Thickness----------- -->
					<div v-if="fpc_stiffener.includes('reinforce_steel')" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{ `Stainless Steel Stiffener Thickness` }} <i @mouseover="alertHelp($event,'readhelp_fpc_stiffener_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.steel_thickness" :items="fpcList.steel_thickness"></quote-check>
						</div>
					</div>
					<!-- ------------ Aluminum Stiffener Thickness----------- -->
					<div v-if="fpc_stiffener.includes('reinforce_aluminium')" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`Aluminum Stiffener Thickness`}} <i @mouseover="alertHelp($event,'readhelp_fpc_stiffener_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.aluminium_thickness" :items="fpcList.aluminium_thickness"></quote-check>
						</div>
					</div>
					<!-- ------------ FR4 Stiffener Thickness----------- -->
					<div v-if="fpc_stiffener.includes('reinforce_fr4')" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`FR4 Stiffener Thickness`}} <i @mouseover="alertHelp($event,'readhelp_fpc_stiffener_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.fr4_thickness" :items="fpcList.fr4_thickness"></quote-check>
						</div>
					</div>
					<!-- ------------ PI Stiffener Thickness----------- -->
					<div v-if="fpc_stiffener.includes('reinforce_pi')" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`PI Stiffener Thickness`}} <i @mouseover="alertHelp($event,'readhelp_fpc_stiffener_thickness')" @mouseleave="alertHelp($event,'readhelp_fpc_stiffener_thickness')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.pi_thickness" :items="fpcList.pi_thickness"></quote-check>
						</div>
					</div>
					<!-- ------------ Adhesive Backing----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`Adhesive Backing`}} <i @mouseover="alertHelp($event,'readhelp_fpc_tape')" @mouseleave="alertHelp($event,'readhelp_fpc_tape')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.tape" :items="fpcList.tape"></quote-check>
						</div>
					</div>
					<!-- ------------ EMI Shielding Film----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`EMI Shielding Film`}} <i @mouseover="alertHelp($event,'readhelp_fpc_emi')" @mouseleave="alertHelp($event,'readhelp_fpc_emi')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.emi" :items="fpcList.emi"></quote-check>
						</div>
					</div>
					<!-- ------------ Conductive Adhesive----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`Conductive Adhesive`}} <i @mouseover="alertHelp($event,'readhelp_fpc_condresin')" @mouseleave="alertHelp($event,'readhelp_fpc_condresin')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.condresin" :items="list.yes_no"></quote-check>
						</div>
					</div>
					<!-- ------------ Impedance Control----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.impedance}}<i @mouseover="alertHelp($event,'readhelp_impedance')" @mouseleave="alertHelp($event,'readhelp_impedance')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.impendance" :items="list.yes_no"></quote-check>
						</div>
					</div>
				</template>

				<template v-if="isRfpc">
					<!-- ------------ Blind/Buried Vias----------- -->
					<div v-if="hasBlindShow" class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG['hdi(buried/blind vias)']}} <i @mouseover="alertHelp($event,'readhelp_hdi buried/blind vias')" @mouseleave="alertHelp($event,'readhelp_hdi buried/blind vias')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="blind" :items="list.yes_no"></quote-check>
						</div>
					</div>
					<!--- HDI 阶数 HDI Structure - - -->
					<div class="quote-box-line" v-if="blindShow">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.hdi_structure}} <i @mouseover="alertHelp($event,'readhelp_rank structure')" @mouseleave="alertHelp($event,'readhelp_rank structure')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.blind" :items="list.blind"></quote-check>
						</div>
					</div>
					<!-- ------------ Impedance Control----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.impedance}}<i @mouseover="alertHelp($event,'readhelp_impedance')" @mouseleave="alertHelp($event,'readhelp_impedance')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.impendance" :items="list.yes_no"></quote-check>
						</div>
					</div>
					<!-- ------------ Plated Half-holes----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.plated_half_holes}} <i @mouseover="alertHelp($event,'readhelp_plated half-holes')" @mouseleave="alertHelp($event,'readhelp_plated half-holes')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.bankong" :items="list.yes_no1"></quote-check>
						</div>
					</div>
					<!-- ------------ Edge Plating----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
							{{LANG.edge_plating}} <i @mouseover="alertHelp($event,'readhelp_plated half-holes')" @mouseleave="alertHelp($event,'readhelp_plated half-holes')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.baobian" :items="list.yes_no1"></quote-check>
						</div>
					</div>
					<!-- ------------ Conductive Adhesive----------- -->
					<div class="quote-box-line">
						<div class="quote-box-tags">
							<span class="t_text">
								{{`Conductive Adhesive`}} <i @mouseover="alertHelp($event,'readhelp_fpc_condresin')" @mouseleave="alertHelp($event,'readhelp_fpc_condresin')" class="icon trans-animate vlm fs-xs quote-help">?</i>
							</span>
						</div>
						<div class="quote-box-items">
							<quote-check v-model="params.condresin" :items="list.yes_no"></quote-check>
						</div>
					</div>
				</template>
			</np-collapse>
		</div>
		<!-- Special Process end -->

		<!-- Personalized Information -->
		<div class="title-bar" :style="{'margin-bottom': showPart[4] ? 0 : '10px'}" @click="handldeShowMore(4)">
			<h2>{{LANG.personalized_service}}</h2>
			<a class="show-more">
				<svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="16" viewBox="0 0 16.027 16" class="icon-arrow" :class="roateMoreArrow(4)"><g transform="translate(-887 -1032)"><rect class="bg" width="16" height="16" transform="translate(887 1032)"/><path class="main" d="M376.125,206.754a.877.877,0,0,1,1.257,0,.92.92,0,0,1,0,1.282l-7.111,7.254a.877.877,0,0,1-1.258,0l-7.112-7.254a.92.92,0,0,1,0-1.282.877.877,0,0,1,1.257,0l6.483,6.613Z" transform="translate(525.384 828.993)"/></g></svg>
			</a>
		</div>
		<div v-show="showPart[4]" class="params-box">
			<np-collapse>
				<!-- ---------Electrical Test--------- -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.electrical_test}} <i @mouseover="alertHelp($event,'readhelp_electrical test')" @mouseleave="alertHelp($event,'readhelp_electrical test')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.test" :items="list.test" @click="paramClick('test')"></quote-check>
					</div>
				</div>
				<!-- ---------Working Gerber--------- -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.approve_working_gerber}} <i @mouseover="alertHelp($event,'rule_working_gerber','500px')" @mouseleave="alertHelp($event,'rule_working_gerber')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.review_file" :items="list.working_gerber"></quote-check>
					</div>
				</div>
				<!-- Reports -->
				<div class="quote-box-line" ref="quote_ulmark">
					<div class="quote-box-tags">
						<span class="t_text">Reports<i @mouseover="alertHelp($event,'delivery_report_tips')" @mouseleave="alertHelp($event,'rule_working_gerber')" class="icon trans-animate vlm fs-xs quote-help">?</i></span> 
					</div>
					<div class="quote-box-items">
						<div style="display:flex;">
							<quote-check v-model="notCheckReport" :items="list.not_check_report" @click="paramClick('report')"></quote-check>
							<quote-check v-model="personality" :items="list.personality" @click="paramClick('report')">
								<template v-slot:itemend="items">
									<i v-if="items.item.value.real !== 'review_file' && items.item.value.real !== 'film_report'"  @click.stop="(e)=>{e.preventDefault()}"
										@mouseover="alertHelp($event,items.item.value.realhelp)"
										@mouseleave="alertHelp($event,items.item.value.realhelp)"
										class="icon mg-l-xs trans-animate vlm fs-xs quote-help"
									>?</i>
								</template>
							</quote-check>
						</div>
						<!-- <p v-if="tow_reportShow" class="fc-quotetips pd-t-xs fs-sm"> {{LANG.delivery_report_tips}}</p> -->
					</div>
				</div>
				<!--- Report Format - - -->
				<div class="quote-box-line" v-if="tow_reportShow">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.report_format}}<i></i> <!-- <i @mouseover="alertHelp($event,'报告形式')" @mouseleave="alertHelp($event,'报告形式')" class="icon trans-animate vlm fs-xs quote-help">?</i> -->
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.report_type" :items="list.report_type"></quote-check>					
					</div>
				</div>
				<!--- UL mark - - -->
				<div v-show="isFr4" class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.ul_mark}} <i @mouseover="alertHelp($event,'readhelp_ul mark')" @mouseleave="alertHelp($event,'ul_mark')" class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.period_format" :items="list.period_format">
							<template slot="end">
								<span @mouseover="ulmarkToggle" @mouseleave="ulmarkToggle"  class="fc-main fs-sm vlm mg-l-md" v-text="LANG.case_display"></span>
							</template>
						</quote-check>
					</div>
				</div>
				<!-- 打叉板 Cross Outs -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							{{LANG.cross_board}} <i @mouseover="alertHelp($event,'readhelp_cross_board')" @mouseleave="alertHelp($event,'readhelp_cross_board')"  class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.cross_board" :items="list.cross_board"></quote-check>
						<p v-show="params.pbnum > 1 && params.cross_board == 2" class="fc-quotetips pd-t-xs fs-sm">{{LANG.pbnum_xout_tip}}</p>
					</div>
				</div>
				<!-- IPC标准 -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							{{LANG.ipc_class}} <i @mouseover="alertHelp($event,'ipc_class_desc')" @mouseleave="alertHelp($event,'ipc_class_desc')"  class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div class="quote-box-items">
						<quote-check v-model="params.acceptance" :items="list.ipc_class"></quote-check>
					</div>
				</div>
				<!-- EQ模式 If Data Conflicts -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
							{{LANG.eq_mode}} <i @mouseover="alertHelp($event,'eq_mode_desc')" @mouseleave="alertHelp($event,'eq_mode_desc')"  class="icon trans-animate vlm fs-xs quote-help">?</i>
						</span>
					</div>
					<div id="eqMode" class="quote-box-items">
						<quote-check v-model="params.eq_mode" :items="list.eq_mode" :class="{'np-input_err': paramsCheck.eqModeTipShow}"></quote-check>
						<p v-show="paramsCheck.eqModeTipShow" class="fc-quotetips pd-t-xs fs-sm">{{LANG.eq_mode_tip}}</p>
					</div>
				</div>
				<!-- Add PO No -->
				<div class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.add_po_no}} 
						</span>
					</div>
					<div class="quote-box-items">
						<np-input class="vlm" type="text" v-model="params.pcb_po_number" width="160px" :maxlength="25">
							<template slot="gt"></template>
						</np-input>
					</div>
				</div>
				<!-- Special request--> <!-- id 用于pcb ＋ stencil时滚动定位-->
				<div id="smdScroll" class="quote-box-line">
					<div class="quote-box-tags">
						<span class="t_text">
						{{LANG.special_requests}} <i></i>
						</span>
					</div>
					<div class="quote-box-items" :data-firststr="pcb_note_first">
						<textarea id="pcbNote" class="quote-note-textarea pd-lg-sm pd-tb-xs"  :class="{'note-err':pcbNoteErr}" :placeholder="LANG.pcb_note_placeholder" v-model="params.pcb_note" @blur="handleValidLen($event)"></textarea>
						<p v-show="pcbNoteErr" class="fc-quotetips pd-t-xs fs-sm"> {{LANG.note_len_tip}}</p>
					</div>
				</div>
			</np-collapse>
		</div>
		<!-- Personalized Information end -->

	</template>
	<StackUpDialog v-if="showStackUp" v-model="showStackUp" :orderParams="stackupParams" :pressing="params.pressing" :pressingList="list.pressing" @syncPressing="handleStackup" />
</div>
</template>

<script>
import pcbUpgerberfile from '@/components/quote/pcb_upgerberfile.vue'
import quoteRelation from '@/components/quote/quote_relation.vue'
import checkQuantity from '@/components/quote/check_quantity.vue'
import quotecheck from '@/_module/quotecheck/index.vue'
import srcselect from '@/_module/srcselect/index.vue'
import npCollapse from '@/_module/collapse/index.vue'
//import checkbox from '@/_module/checkbox/index.vue'
import input from '@/_module/input/index.vue'
import singleMinxin from '@/mixins/quote/pcb_single.js'
import pubmixin from '@/mixins/quote/public_mixin.js'
import pcbCount from '@/mixins/quote/pcb_count.js'
import StackUpDialog from '@/components/pcb/stackup-dialog/index.vue'
/*
mixin 爲了通用 導出為函數，pcb 以及fpc rfpc都可以使用，注意要保持數據格式的一致性，否則會出錯
參數傳 fpc/pcb... 根據材質不同傳不同參數注意vuex中的值
*/
export default {
	name: 'common_rfpc',
	mixins:[pcbCount,singleMinxin("pcb","blayer"),pubmixin("pcb")],
	data(){
		return {
			radio: '',
			//剛柔版與fpc 唯一差別是層數不一樣 其他都是一樣的規則
			params:{
				fid:'',
				pcbParsingFile: {},
				pcbfile:'',
				history_pcb_order_sn:0,
				isgerber:'',
				pbnum: 1,//拼版款数
				shipment_report:'',//出货报告
				blind:'', //HDI 0 , 1 ,2 1阶2阶
				plate_type:'',
				thermalc: 1, //Thermal Conductivity
				rogers:'',  //Rogers
				board_tg: '', // TG defaultValue.board_tg ||
				blayer: "", //Layer CountdefaultValue.blayer
				bheight: '',//板子厚度defaultValue.bheight
				color: '',//阻焊颜色defaultValue.color ||
				charcolor :'',//字符颜色
				copper : '',//铜箔厚度defaultValue.copper ||
				insidecopper: '',//defaultValue.insidecopper ||内层铜厚
				lineweight: '', //最小线宽/线距
				vias: '', //Min. Drilled Hole
				zknum: 0,//孔密度
				cjarea: 0,//沉金面积
				cover:'',//阻焊覆盖
				spray:'',//焊盘喷镀 defaultValue.spray ||
				cjh:  '',//defaultValue.cjh ||
				beveledge:  '', //金手指斜边defaultValue.beveling ||
				impendance : '',//阻抗defaultValue.impendance ||
				via_in_pad : '',
				testpoint: '' , //测试点数defaultValue.testPoints ||
				test :'',//飞针测试'Sample Test Free'
				bankong: '',
				baobian: '', // 包边
				//dieceng: "Stacking according to factory design", //叠层结构
				pressing: '', // 叠层结构
				slice_report: '', //产品报告
				has_period: '',
				film_report: 0, // 实物菲林
				period_format:0,
				pcb_po_number:'',
				pcb_note:'',
				review_file: '0',
				report_type:'',
				cross_board: 1, //打叉板
				pad_width: '', // 焊盘宽度
				eq_mode: 0, // EQ模式
				plug_in_holes: 0, // 插件孔
				acceptance: '',
				electrogilding_thickness:'', // 电金厚度
				fpc_thickness: 0.2, // fpc板厚
				fpc_cover:'Coverlay (1-side)', // 阻焊类型
				fpc_color:'Yellow', // FPC颜色
				fpc_charcolor:'White', // FPC字符
				fpc_material: 'Adhesive ED', // FPC材料
				fpc_pi_thickness: '12.50', // PI厚度
				fpc_outsidecopper: '1/3', // FPC外层铜厚
				fpc_insidecopper: '', // FPC内层铜厚
				fpc_forming: 'Laser Forming', // 成型方式
				reinforce_steel: 0, // 钢片补强:0否,1是
				steel_thickness: '0.1', // 钢片补强厚度
				reinforce_aluminium: 0, // 铝片补强
				aluminium_thickness: '0.3', // 铝片补强厚度
				reinforce_fr4: 0, // FR4补强
				fr4_thickness: '0.1', // FR4补强厚度
				reinforce_pi: 0, // PI补强
				pi_thickness: '0.1', // PI补强厚度
				reinforce_num: 0,  // 补强数量
				tape: 0, // 背胶
				emi: '', // 电磁膜
				condresin: 0, // 导电胶
				fpc_blayer: 2
			},
			//特殊工艺
			specialprocess:[],
			personality:[],
			list:{
				plate_type:[
					{word:"Fr-4",real:"Fr-4",keys:"fr-4"},
					{word:"Aluminum",real:"Aluminum",keys:"aluminum"},
					{word:"Copper",real:"Copper",keys:"copper"},
					{word:"Flexible Boards",real:"Flex board",keys:"fpc"},
					{word:"Rigid-Flex Board",real:"Rigid-Flex board",keys:"rfpc"},
					// {word:"Rogers",real:"Rogers",keys:"rogers"},
				],
				blayer:[
					{real:1,word:"1",keys:"1"},
					{real:2,word:"2",keys:"2"},
					{real:4,word:"4",keys:"4"},
					{real:6,word:"6",keys:"6"},
					{real:8,word:"8",keys:"8"},
					{real:10,word:"10",keys:"10"},
					{real:12,word:"12",keys:"12"},
					{real:14,word:"14",keys:"14"},
					{real:16,word:"16",keys:"16"},
					{real:18,word:"18",keys:"18"},
					{real:20,word:"20",keys:"20"},
					{real:22,word:"22",keys:"22"}
				],
				fpcLayer: [
					{real:1,word:"1",keys:"1"},
					{real:2,word:"2",keys:"2"},
					{real:3,word:"3",keys:"3"},
					{real:4,word:"4",keys:"4"},
					{real:5,word:"5",keys:"5"},
					{real:6,word:"6",keys:"6"},
				],
				rfpcLayer:[
					{real:2,word:"2",keys:"2"},
					{real:4,word:"4",keys:"4"},
					{real:6,word:"6",keys:"6"},
					{real:8,word:"8",keys:"8"},
					{real:10,word:"10",keys:"10"},
					{real:12,word:"12",keys:"12"},
					{real:14,word:"14",keys:"14"},
					{real:16,word:"16",keys:"16"},
					{real:18,word:"18",keys:"18"},
					{real:20,word:"20",keys:"20"},
					{real:22,word:"22",keys:"22"},
					{real:24,word:"24",keys:"24"},
					{real:26,word:"26",keys:"26"},
					{real:28,word:"28",keys:"28"},
					{real:30,word:"30",keys:"30"},
					{real:32,word:"32",keys:"32"}
				],
				rogersLayer:[
					{real:2,word:"2",keys:"2"},
					{real:4,word:"4",keys:"4"},
					{real:6,word:"6",keys:"6"},
					{real:8,word:"8",keys:"8"},
					{real:10,word:"10",keys:"10"},
					{real:12,word:"12",keys:"12"},
					{real:14,word:"14",keys:"14"},
					{real:16,word:"16",keys:"16"},
					{real:18,word:"18",keys:"18"},
					{real:20,word:"20",keys:"20"},
					{real:22,word:"22",keys:"22"},
					{real:24,word:"24",keys:"24"},
					{real:26,word:"26",keys:"26"},
					{real:28,word:"28",keys:"28"},
					{real:30,word:"30",keys:"30"},
					{real:32,word:"32",keys:"32"},
					{real:34,word:"34",keys:"34"},
					{real:36,word:"36",keys:"36"},
					{real:38,word:"38",keys:"38"},
					{real:40,word:"40",keys:"40"}
				],
				thermalc:[{word:"1W",real: "1"},{word:"2W",real: "2"},{word:"3W",real: "3"}],
				board_tg:[{real:"TG130",word:"TG130"},{real:"TG135",word:"TG135"},{real:"TG150",word:"TG150"},{real:"TG155",word:"TG155"},{real:"TG170",word:"TG170"}],
				rogers: [{real:"Rogers 4003C",word:"Rogers 4003C"},{word:"Rogers 4350B",real:"Rogers 4350B"}],
				bheight: [],
				color:[
					{css: "Green", real:"Green",word:"Green",keys:"green"},
					{css: "Red", real:"Red",word:"Red",keys:"red"},
					{css: "Yellow", real:"Yellow",word:"Yellow",keys:"yellow"},
					{css: "Blue", real:"Blue",word:"Blue",keys:"blue"},
					{css: "White", real:"White",word:"White",keys:"white"},
					{css: "High_Reflectivity_White", real: "HR White", word: "High Reflectivity White", keys: "high reflectivity white"},
					{css: "Black", real:"Black",word:"Black",keys:"black"},
					{css: "Matte_Black", real:"Matt Black",word:"Matte Black",keys:"matt black"},
					{css: "Purple", real:"Purple",word:"Purple",keys:"purple"},
					{css: "Matte_Green", real:"Matt Green",word:"Matte Green",keys:"matte green"},
					{css: "None", real: "Clear", word: "Clear", keys: "clear"}
				],
				rogerscolor:[
					{css: "Green", real:"Green",word:"Green",keys:"green"},
					{css: "Matte_Green", real:"Matt Green",word:"Matte Green",keys:"matte green"},
					{css: "Red", real:"Red",word:"Red",keys:"red"},
					{css: "Yellow", real:"Yellow",word:"Yellow",keys:"yellow"},
					{css: "Blue", real:"Blue",word:"Blue",keys:"blue"},
					{css: "White", real:"White",word:"White",keys:"white"},
					{css: "Black", real:"Black",word:"Black",keys:"black"},
					{css: "Matte_Black", real:"Matt Black",word:"Matte Black",keys:"matt black"},
					{css: "Purple", real:"Purple",word:"Purple",keys:"purple"},
					{css: "Gray", real: "Grey", word: "Gray", keys: "gray"},
					{css: "Orange", real:"Orange",word:"Orange",keys:"orange"},
					{css: "Silver", real: "Silver", word: "Silver", keys: "silver"},
					{css: "None", real: "Clear", word: "Clear", keys: "clear"}
				],
				charcolor:[{css: "White",real:"White",word:"White",keys:"white"}, {css: "Black",real:"Black",word:"Black",keys:"black"},{css: "None", real: "Clear", word: "Clear", keys: "clear"}],
				test:[
					{ "real": "Sample Test Free", "word": "100% FPT for Prototypes", "keys": "sample test free" },
					{ "real": "Batch Flying Probe Test", "word": "100% FPT for Batches", "keys": "aoi+flying test" },
					{ "real": "Batch Fixture Test", "word": "Test Fixture", "keys": "aoi+fixture" },
					// { "real": "Sampling Tests", "word": "Random Sampling FPT", "keys": "aoi+sampling test" },
					{ "real": "Visual Inspection", "word": "Visual Inspection", "keys": "fqc visual inspections free" }
				],
				copper: [
					{real:0.5,word:'0.5oz'},
					{real:1,word:'1oz'},
					{real:1.5,word:'1.5oz'},
					{real:2,word:'2oz'},
					{real:3,word:'3oz'},
					{real:4,word:'4oz'},
					{real:5,word:'5oz'},
					{real:6,word:'6oz'}
				],
				insidecopper: [
					{real:0.5,word:'0.5oz'},{real:1,word:'1oz'}, {real:2,word:'2oz'},
					{real:3,word:'3oz'},{real:4,word:'4oz'},{real:5,word:'5oz'},
					{real:6,word:'6oz'}
				],
				lineweight: [{real:10, word: '10/10mil↑'},{real:8, word: '8/8mil'},{real:6, word: '6/6mil'},{real:5,word:'5/5mil'},{real:4,word:'4/4mil'},{real:3.5,word:'3.5/3.5mil'},{real:3,word:'3/3mil'},{real:2,word:'2/2mil'}],
				vias: [
					{real: 1, word: '1.0mm↑'},
					{real: 0.5, word: '0.5mm'},
					{real: 0.3, word: '0.3mm'},
					{real: 0.25, word: '0.25mm'},
					{real: 0.2, word: '0.2mm'},
					{real: 0.175, word: '0.175mm'},
					{real: 0.15, word: '0.15mm'}
				],
				cover: [
					{ real: 'Tenting Vias', word: 'Tented Vias', keys: 'tenting vias', realhelp: 'readhelp_tenting_vias' },
					{ real: 'Vias not covered', word: 'Opened Vias', keys: 'vias not covered', realhelp: 'readhelp_vias_not_covered' },
					{ real: 'Solder Mask Plug (IV-B)', word: 'Solder Mask Plug (IV-B)', keys: 'solder mask plug (iv-b)', realhelp: 'readhelp_solder_mask_plug' },
					{ real: 'Non-Conductive Fill & Cap (VII)', word: 'Non-Conductive Fill & Cap (VII)', keys: 'non-conductive fill & cap (vii)', realhelp: 'readhelp_non-conductive_fill_cap' }
				],
				spray: [
					{real:"HASL",word:"HASL",keys:"hasl"},
					{real:"Lead free HASL",word:"Lead Free HASL",keys:"lead free hasl"},
					{real:"ENIG",word:"ENIG",keys:"enig"},
					{real:"OSP",word:"OSP",keys:"osp"},
					{real:"Electroplated Gold",word:"Electroplated Gold",keys:"electroplated gold"},
					{real:"Immersion Silver",word:"Immersion Silver",keys:"immersion silver"},
					{real:"Immersion Tin",word:"Immersion Tin",keys:"Immersion Tin"},
					{real:"ENIG + OSP",word:"ENIG + OSP",keys:"ENIG + OSP"},
					{real:"Gold Finger Plating",word:"Gold Finger Plating",keys:"Gold Finger Plating"}
				],	
				cjh:[{word:'1μ″',real: '1'},{word:'2μ″',real: '2'},{word:'3μ″',real: '3'}],
				specialprocess:[
					{real:"blind",word:"HDI(Buried/blind vias)",type:1,realhelp:"readhelp_hdi buried/blind vias",keys:"hdi(buried/blind vias)"},
					{real:"impendance",word:"Impedance",type:1,realhelp:"readhelp_impedance",keys:"impedance"},
					//层叠下一版开始做
					//{real:"Multi-layer laminated structure",word:"Multi-layer laminated structure",type:1},
					{real:"beveledge",word:"Beveling of G/F",type:1,realhelp:"readhelp_beveling of g/f",keys:"beveling_of_g_f"},
					{real:"bankong",word:"Plated Half-holes/Castellated Holes",type:1,realhelp:"readhelp_plated half-holes",keys:"plated_half_holes_plated_through_hole1"},
					// {real:"via_in_pad",word:"Pad Hole",type:1,realhelp:"readhelp_pad hole",keys:"pad_hole"}
				],
				pressing:[{word:'No Requirement',keys:'no_requirement',real: ''},{word:'Customer Specified Stack up',keys:'customer_specified_stack_up',real: 'Customer Specified Stack up'}],
				personality:[
					// {real:"review_file",word:"Approve Working Gerber",type:1,keys:"approve_working_gerber"},
					{real:"shipment_report",word:"Production Report",type:1,realhelp:"readhelp_delivery_report",keys:"delivery_report"},
					{real:"slice_report",word:"Microsection Analysis Report",type:1,realhelp:"readhelp_analysis",keys:"microsection_analysis_report1"},
					// {real:"has_period",word:"UL Mark",type:1,realhelp:"readhelp_ul mark",keys:"ul_mark"},
					{real:"film_report",word:"Production Films",type:1,keys:"film"}
				],
				not_check_report:[
					{real:"not_required",word:"Not Required",type:1,keys:"not_required"}
				],
				blind:[{real:1,word:"Rank 1",keys:"rank_1"},{real:2,word:"Rank 2",keys:"rank_2"},{real:3,word:"Rank 3",keys:"rank_3"}],
				//via_in_pad: [{real:"Plug Epoxy",word:"Plug Epoxy"},{real:"Plug Epoxy + Filling (VOP)",word:"Plug Epoxy + Filling (VOP)"}],
				report_type:[{real:2,word:"Paper",keys:"paper"},{real:1,word:"Electronic",keys:"electronic"}],
				period_format:[{real:0,word:"No",keys:"no"},{real:2,word:"UL+Week/Year",keys:"ul_week_year"},{real:1,word:"UL+Year/Week",keys:"ul_year_week"}],
				cross_board:[{real:2,word:"Not Accept",keys:"not_accept_cross_board"},{real:1,word:"Accept",keys:"accept_cross_board"}],
				yes_no: [{real:0,word:"No",keys:"no"},{real:1,word:"Yes",keys:"yes"}],
				yes_no1: [{real:'',word:"No",keys:"no"},{real:1,word:"Yes",keys:"yes"}],
				working_gerber: [{real:0,word:"Not Required",keys:'not_required'},{real:2,word:"Require Approval", keys:'require_approval'}],
				eq_mode: [
					{ real: '1', word: 'Follow Order Parameters', keys: 'follow_order_parameters'},
					{ real: '2', word: 'Follow Files', keys: 'follow_files' },
					{ real: '3', word: 'Ask for Confirmation', keys: 'ask_for_confirmation' }
				],
				plug_in_holes: [{real:0,word:"No",keys:"no"},{real:1,word:"Yes",keys:"yes"}],
				ipc_class: [{real:1,word:"IPC Level 2 Standard", keys:"ipc_level_2_standard"},{real:2,word:"IPC Level 3 Standard", keys:"ipc_level_3_standard"}]
			},
			fpcList: {
				fpc_thickness: [
					{real: 0.1, word: '0.1mm'},
					{real: 0.13, word: '0.13mm'},
					{real: 0.15, word: '0.15mm'},
					{real: 0.2, word: '0.2mm'},
					{real: 0.25, word: '0.25mm'},
					{real: 0.3, word: '0.3mm'},
					{real: 0.35, word: '0.35mm'},
					{real: 0.4, word: '0.4mm'},
					{real: 0.45, word: '0.45mm'}
				],
				fpc_cover: [
					{real: 'Coverlay (1-side)', word: 'Coverlay (1-side)'},
					{real: 'Coverlay (2-sides)', word: 'Coverlay (2-sides)'},
					{real: 'Solder Mask (1-side)', word: 'Solder Mask (1-side)'},
					{real: 'Solder Mask (2-sides)', word: 'Solder Mask (2-sides)'},
				],
				fpc_color:[
					{css: "Green", real:"Green",word:"Green",keys:"green"},
					{css: "Yellow", real:"Yellow",word:"Yellow",keys:"yellow"},
					{css: "Red", real:"Red",word:"Red",keys:"red"},
					{css: "Orange", real:"Orange",word:"Orange",keys:"orange"},
					{css: "Black", real:"Black",word:"Black",keys:"black"},
					{css: "White", real:"White",word:"White",keys:"white"},
					{css: "Silver", real: "Silver", word: "Silver", keys: "silver"},
					{css: "None", real: "Clear", word: "Clear", keys: "clear"},
				],
				fpc_charcolor:[
					{css: "White", real:"White",word:"White",keys:"white"},
					{css: "Black", real:"Black",word:"Black",keys:"black"},
					{css: "None", real: "Clear", word: "Clear", keys: "clear"}
				],
				fpc_material: [
					{real: 'Adhesive ED', word: 'Adhesive ED'},
					{real: 'Adhesiveless ED', word: 'Adhesiveless ED'},
					{real: 'Adhesive RA', word: 'Adhesive RA'},
					{real: 'Adhesiveless RA', word: 'Adhesiveless RA'},
				],
				fpc_pi_thickness: [
					{real: '12.50', word: '12.5um'},
					{real: '25.00', word: '25um'},
					{real: '50.00', word: '50um'},
				],
				fpc_outsidecopper: [
					{real: '1/3', word: '1/3oz'},
					{real: '0.5', word: '0.5oz'},
					{real: '1', word: '1oz'},
					// {real: '2', word: '2oz'},
				],
				fpc_insidecopper: [
					{real: '1/3', word: '1/3oz'},
					{real: '0.5', word: '0.5oz'},
					{real: '1', word: '1oz'},
				],
				fpc_forming: [
					{real: 'Laser Forming', word: 'Laser Forming'},
					{real: 'Mold Forming', word: 'Mold Forming'},
				],
				fpc_forming1: [
					{real: 'Regular Punching', word: 'Regular Punching'},
					{real: 'Mid Precision Punching', word: 'Mid Precision Punching'},
					{real: 'High Precision Punching', word: 'High Precision Punching'},
				],
				fpc_forming1: [
					{real: 'Regular Punching', word: 'Regular Punching'},
					{real: 'Mid Precision Punching', word: 'Mid Precision Punching'},
					{real: 'High Precision Punching', word: 'High Precision Punching'},
				],
				fpc_stiffener: [
					{type: '1', real: 'reinforce_steel', word: 'Stainless Steel Stiffener'},
					{type: '1', real: 'reinforce_aluminium', word: 'Aluminum Stiffener'},
					{type: '1', real: 'reinforce_fr4', word: 'FR4 Stiffener'},
					{type: '1', real: 'reinforce_pi', word: 'PI Stiffener'},
				],
				steel_thickness: [
					{real: 0.1, word: '0.1mm'},
					{real: 0.15, word: '0.15mm'},
					{real: 0.2, word: '0.2mm'},
					{real: 0.25, word: '0.25mm'},
					{real: 0.3, word: '0.3mm'},
					{real: 0.4, word: '0.4mm'},
					{real: 0.5, word: '0.5mm'}
				],
				aluminium_thickness: [
					{real: 0.3, word: '0.3mm'},
					{real: 0.4, word: '0.4mm'},
					{real: 0.5, word: '0.5mm'},
					{real: 0.6, word: '0.6mm'},
					{real: 0.7, word: '0.7mm'},
					{real: 0.8, word: '0.8mm'},
					{real: 0.9, word: '0.9mm'},
					{real: 1.0, word: '1.0mm'},
					{real: 1.1, word: '1.1mm'},
					{real: 1.2, word: '1.2mm'}
				],
				fr4_thickness: [
					{real: 0.1, word: '0.1mm'},
					{real: 0.2, word: '0.2mm'},
					{real: 0.3, word: '0.3mm'},
					{real: 0.4, word: '0.4mm'},
					{real: 0.5, word: '0.5mm'},
					{real: 0.6, word: '0.6mm'},
					{real: 0.7, word: '0.7mm'},
					{real: 0.8, word: '0.8mm'},
					{real: 1.0, word: '1.0mm'},
					{real: 1.2, word: '1.2mm'},
					{real: 1.5, word: '1.5mm'},
				],
				pi_thickness: [
					{real: 0.05, word: '0.05mm'},
					{real: 0.1, word: '0.1mm'},
					{real: 0.15, word: '0.15mm'},
					{real: 0.175, word: '0.175mm'},
					{real: 0.2, word: '0.2mm'},
					{real: 0.225, word: '0.225mm'},
					{real: 0.25, word: '0.25mm'},
				],
				tape: [
					{real: 0, word: "Not Required"},
					{real: 1, word: "Required"}
				],
				emi: [
					{real: '', word: "Not Required"},
					{real: 'Low R (1-side)', word: "Low R (1-side)"},
					{real: 'Low R (2-sides)', word: "Low R (2-sides)"}
				]
			},
			fpc_forming_method: 'Laser Forming', // fpc成型方式
			fpc_stiffener: [], // fpc补强
			not_check_fpc_stiffener: ['not_required'],
			resolvedFileData: {}, // 文件解析出来的数据
			pcbNoteErr: false,
			showPart: {
				1: true,
				2: true,
				3: true,
				4: true,
				5: true, // fpc参数
				6: true  // 硬板参数
			},
			hasBlindShow: false,
			blind: 0,
			sizeTip: '',
			showPcsTip: false,
			pcsCountTip: '',
			plateTypeChangeCount : 0,
			notCheckReport: [],
			isClick:{ // 手动变更改的参数
				board_tg: false,
				copper: false,
				insidecopper: false,
				test: false
			},
			isSetPcbParams: false, // 是否正在设置pcb参数
			recommendStackUp: [],
			showStackUp: false
		}
	},
	mounted(){
		this.setulmarkHeight();
		setTimeout(()=>{
			this.seturlDefault();
			this.seturlDefaultFromDfm()

			if(!(this.params.bcount && this.params.blength && this.params.bwidth) && !this.isChangeParams && !this.isSetPageData){
				this.params.bcount = 5
				this.params.blength = 100
				this.params.bwidth = 100
				this.$store.commit('setIsSystemQuote', true)
			}
		})	
		this.$bus.$on('analysisFileSuccessEvent', (res) => {
			this.resolveGerberSuccess(res)
		})
		this.$bus.$on('analysisFileFailEvent', () => {
			this.resolveGerberFailed()
		})
		this.$bus.$on('ladderCountChangeEvent', (bcount) => {
			console.log(654, bcount)
			this.params.bcount = bcount
			// 由于params.bcount改变后，会立即触发计价，但是此时不需要阶梯价的参数没法传入，因此，使用延时器，将不需要阶梯价的参数传到计价接口
			setTimeout(() => {
				this.$store.commit("setQuoteParams",{value: bcount,key:"pcb_params.bcount"});
				this.$store.commit("setIsStepClick", true)
				// PCBA 点击阶梯价格改变数量不在PCB这边调用计价方法
				if(this.stay == 'smt'){
					return false
				}
				//執行計價方法
				this.countCalc({not_show_step: 1});
			}, 100)
		})
		// this.handleOpenViaInPadPopup()

		console.log('pcb *-*-*-', this.isChangeParams, this.changeParams)
	},
	computed: {
		//后期如果需要pcb所有都做交互 start 这里写到mixins/pcb_single.js 中
		// isBlengthErr(){	
		// 	if(this.isCalcBtn){
				
		// 		if(!this.params.blength){
		// 			return true;
		// 		} 
		// 	}
		// 	return false;
		// },
		// isBwidthErr(){
		// 	if(this.isCalcBtn){
		// 		if(!this.params.bwidth) {
		// 			return true;
		// 		}
		// 	}
		// 	return false;
		// },
		// isBcountErr(){
		// 	if(this.isCalcBtn){
		// 		if(!this.params.bcount) {
		// 			return true;
		// 		}
		// 	}
		// 	return false;
		// },
		// isCalcBtn(){
		// 	return this.$store.getters.getisCalcBtn;
		// },
		//后期如果需要pcb所有都做交互 start 这里写到mixins/pcb_single.js 中 end
		pcb_note_first(){
			return this.$store.getters.getFirstTips;
		},
		// // 表面处理OSP限制 min:80*50mm  参数字段-spray
		// isDisableOsp(){
		// 	let flag= (this.params.blength && this.params.bwidth) && (( this.params.blength < 80 ||  this.params.bwidth < 50 ) && ( this.params.bwidth < 80 ||  this.params.blength < 50 ))
		// 	this.setAttr(this.list.spray,{value: flag,reverse:false,items:['OSP']})
		// 	return flag
		// },
		showViaProcessTip(){
			let flag= false
			if( (this.resolvedFileData.via_in_pad == 'Have' || this.resolvedFileData.via_on_smd_pad == 'Have') && this.params.cover != 'Non-Conductive Fill & Cap (VII)' ){
				flag = true
			}
			return flag
		},
		languagePackage(){
			return this.$store.getters.getLanguangeData || {LANG:null,MLANG:null};
		},
		diableMinusPbnum(){
			return this.params.pbnum == 1
		},
		diablePlusPbnum(){
			return this.params.blayer > 3 && this.params.blayer <= 20 && this.params.pbnum >= 4
		},
		showPbnumLimitTip(){
			return this.params.blayer > 3 && this.params.blayer <= 20 && this.params.pbnum > 4
		},
		paramsCheck(){
			return this.$store.state.quote.paramsCheck
		},
		// 解析线宽线距为空值时显示
		showLineweightTip() {
			return this.resolvedFileData.lineweight == ''
		},
		isChangeParams() {
			return this.$store.state.isChangeParams
		},
		changeParams() {
			return this.$store.state.changeParams
		},
		isSetPageData() {
			return this.isSetPcbParams
		},
		showRecommendStackup() {
			return this.isFr4 && this.params.blayer > 2
		},
		stackupParams() {
			const stackupParams = {
				blayer: this.params.blayer,
				bheight: this.params.bheight,
				copper: this.params.copper,
				insidecopper: this.params.insidecopper,
				// blind: this.params.blind || 0,
				hdi: this.params.blind || 0
			}
			return stackupParams
		}
	},
	methods:{
		seturlDefault(){
			// 从在线dfm跳转回来的，不执行
			if(window.location.href.includes('isDfm=1') || window.location.href.includes('iskicad=1')){
				return false
			}
			// 获取url参数
			var searchUrl = decodeURIComponent(window.location.href.split('?')[1] || '');
			var searchUrl2 = searchUrl.split('#')[0] || '';
			let queryObj = {}
			// console.log(695, searchUrl2, searchUrl)
			var queryArr = searchUrl2.split("&");
			for (var i=0;i<queryArr.length;i++) {
				var pair = queryArr[i].split("=");
				queryObj[pair[0]] = pair[1]
			}	
			
			queryObj = this.$route.query || {}

			if(window.sessionStorage.getItem('pcbParams')){
				const strParams = window.sessionStorage.getItem('pcbParams')
				const params = (strParams !== 'undefined' && strParams != 'null') && JSON.parse(window.sessionStorage.getItem('pcbParams')) || {}
				params.bwidth = params.bwidth * 10
				params.blength = params.blength * 10

				queryObj = {...this.params, ...params}
				window.sessionStorage.removeItem('pcbParams')
			}

			console.log(701, queryObj)	
			// 赋值到页面
			let specialprocessArr = []
			let personalityArr = []
			for(let k in queryObj){		
				this.params[k] = queryObj[k];		
				this.$set(this.isClick, k, true)
				if(k == 'width' || k == 'bwidth'){
					this.params.bwidth = queryObj[k]
				}
				if(k == 'length' || k == 'blength'){
					this.params.blength = queryObj[k]
				}
				if(k == 'count' || k == 'bcount'){
					this.params.bcount = queryObj[k];
					this.$set(this.isClick, 'bcount', true)
				}
				if(k == 'layer' || k == 'blayer'){
					setTimeout(() => {
						this.params.blayer = queryObj[k];
						this.$set(this.isClick, 'blayer', true)
					}, 100)
					
				}

				// specialprocess
				if(k == 'blind' && queryObj[k] != 0){
					specialprocessArr.push('blind')
					this.blind = 1
				}
				if(k == 'impendance' && queryObj[k] == 1){
					specialprocessArr.push('impendance')
				}
				if(k == 'beveledge' && queryObj[k] == 1){
					specialprocessArr.push('beveledge')
				}
				if(k == 'bankong' && queryObj[k] == 1){
					specialprocessArr.push('bankong')
				}
				if(k == 'via_in_pad' && queryObj[k] == 'Have'){
					// specialprocessArr.push('via_in_pad')
					this.resolvedFileData.via_in_pad = 'Have'
				}

				if(k == 'via_on_smd_pad' && queryObj[k] == 'Have'){
					this.resolvedFileData.via_on_smd_pad = 'Have'
				}

				this.specialprocess = specialprocessArr

				// Personalized Information
				if(k == 'shipment_report' && queryObj[k] == 1){
					personalityArr.push('shipment_report')
				}
				if(k == 'slice_report' && queryObj[k] == 1){
					personalityArr.push('slice_report')
				}
				if(k == 'film_report' && queryObj[k] == 1){
					personalityArr.push('film_report')
				}
				// if(k == 'review_file' && queryObj[k] == 2){
				// 	personalityArr.push('review_file')
				// }
				// if(k == 'has_period' && queryObj[k] == 6){
				// 	personalityArr.push('has_period')
				// }

				// if(k == "has_period" && queryObj[k] == 2){
				// 	this.params.period_format = 0
				// }

				if(k == 'pad_width' && queryObj[k]){
					this.params.pad_width = queryObj[k]
				}

				if(this.params.has_period == 2) {
					this.params.period_format = 0
				}
			}	
			this.personality = personalityArr
			console.log(756, this.params)
		},
		// 处理dfm带回的计价参数
		seturlDefaultFromDfm(){
		
			const query=this.$route.query
			const analyseId=query.aid
			const isDfm=query.isDfm
			if(!analyseId){
				return false
			}
			const nextpcbData=JSON.parse(localStorage.getItem('nextdfm'+analyseId))
			if(!nextpcbData){
				return false
			}
			this.isSetPcbParams = true
			console.log('start seturlDefaultFromDfm', nextpcbData, analyseId)
			const queryObj=JSON.parse(JSON.stringify(nextpcbData?.params)) || {}
			Object.assign(this.params,queryObj)
			// 赋值到页面
			let specialprocessArr = []
			let personalityArr = []
			for(let k in queryObj){		
				this.$set(this.isClick, k , true)
				this.params[k] = queryObj[k];		
				if(k == 'width' || k == 'bwidth'){
					this.params.bwidth = queryObj.bwidth_init ? this.$tools.keepDecimal(queryObj.bwidth_init * 10, 1) : this.$tools.keepDecimal(queryObj[k] * 10, 1);
				}
				if(k == 'length' || k == 'blength'){
					this.params.blength = queryObj.blength_init ? this.$tools.keepDecimal(queryObj.blength_init * 10, 1) : this.$tools.keepDecimal(queryObj[k] * 10, 1);
				}
				if(k == 'count' || k == 'bcount'){
					this.params.bcount = queryObj[k];
				}
				if(k == 'layer' || k == 'blayer'){
					this.params.blayer = queryObj[k];
				}

				// specialprocess
				if(k == 'blind' && queryObj[k] != 0){
					specialprocessArr.push('blind')
					this.blind = 1
				}
				if(k == 'impendance' && queryObj[k] == 1){
					specialprocessArr.push('impendance')
				}
				if(k == 'beveledge' && queryObj[k] == 1){
					specialprocessArr.push('beveledge')
				}
				if(k == 'bankong' && queryObj[k] == 1){
					specialprocessArr.push('bankong')
				}
				if(k == 'via_in_pad' && queryObj[k] == 'Have'){
					// specialprocessArr.push('via_in_pad')
					this.resolvedFileData.via_in_pad = 'Have'
				}

				if(k == 'via_on_smd_pad' && queryObj[k] == 'Have'){
					this.resolvedFileData.via_on_smd_pad = 'Have'
				}

				// Personalized Information
				if(k == 'shipment_report' && queryObj[k] == 1){
					personalityArr.push('shipment_report')
				}
				if(k == 'slice_report' && queryObj[k] == 1){
					personalityArr.push('slice_report')
				}
				if(k == 'film_report' && queryObj[k] == 1){
					personalityArr.push('film_report')
				}
				// if(k == 'review_file' && queryObj[k] == 2){
				// 	personalityArr.push('review_file')
				// }
				// if(k == 'has_period' && queryObj[k] == 6){
				// 	personalityArr.push('has_period')
				// }

				// if(k == "has_period" && info[k] == 2){
				// 	this.params.period_format = 0
				// }
				
			}

			if (specialprocessArr.length) {
				this.specialprocess = specialprocessArr
			}


			if (personalityArr.length) {
				this.personality = personalityArr
			}
			
			if(this.params.has_period == 2) {
				this.params.period_format = 0
			}
			console.log(7561, this.params)

			// this.isSetPcbParams = false
			console.log('end seturlDefaultFromDfm')
			
		},
		setulmarkHeight(){
			let element = this.$refs.quote_ulmark;
			if(element){
			let offset = this.$tools.getOffset(element);
				this.$store.commit("setOffset",{key:"quote_ulmark",value:offset});	
			}				
		},
		ulmarkToggle(e){
			let html = `
				<h3 style="font-weight:bold;">
					${this.LANG.case_display}
				</h3>
				<p class="pd-t-sm">${this.LANG.case_display_tips1}</p>
				<p class="pd-t-sm">
					<img src="//static.nextpcb.com/js/newmain/images/quote-casedisplay-30.jpg">
				</p>
				<p class="pd-t-sm" style="max-width:410px;">${this.LANG.case_display_tips2}</p>
			`;
			this.$alert.dialog({
				position:"right",
				content: html,
				show:true
			},e)
		},
		resolveGerberSuccess(res, iskidcard){
			this.params.isgerber = 0;
			this.resolvedFileData = res
			// 设置拼版的参数
			this.params.units = res.units
			this.params.pad_width = res.pad_width
			this.$store.commit("setQuoteParams",{value:res.pad_width,key:"pcb_params.pad_width"})

			console.log(728, res, iskidcard)
			if(!iskidcard) this.sethistoryOrderInfo(res);
			if(!this.params.bcount){
				this.bcountCheck = true;
				this.sizeCheck = true;
			}
			
			if(this.params.units !=1 ){
				this.layoutxCheck = true
				this.layoutyCheck = true
			}

			if(this.params.units == 3 && !this.params.layoutx && !this.params.layouty){
				this.params.layoutx = 1
				this.params.layouty = 1
				this.layoutxCheck = false
				this.layoutyCheck = false
			}

			// 铝基板、铜基板 层数大于2，默认1层板
			if ((this.isAluminum || this.isCopper) && this.resolvedFileData.blayer > 2) {
				this.params.blayer = 1
			}

			if (this.isCopper) {
				this.params.blayer = 1
			}

			if (this.isRogers && this.params.blayer == 1) {
				this.params.blayer = 2
			}

			// 线宽线距为空值
			if(res.lineweight == ''){
				this.params.lineweight = 6
			}

			// 有盘中孔，弹窗提示
			// Non-Conductive Fill & Cap (VII)
		},
		resolveGerberFailed(){
			if(!this.params.bcount){
				this.bcountCheck = true;
				this.sizeCheck = true;
			}	
		},

		getfid(fid, pcbParsingFile){
			this.params.fid = fid;
			this.params.pcbParsingFile = pcbParsingFile
			this.$store.commit("setQuoteParams",{value:fid,key:"aside_param.gerber_file_id"});	
			this.$store.commit("setQuoteParams",{value:pcbParsingFile ? pcbParsingFile.url : '',key:"aside_param.gerber_file"});			
		},
		watchOpenPopup(){
			setTimeout(()=>{
				if(this.LANG.via_in_pad){
					this.handleOpenViaInPadPopup()
				}
				else{
					this.watchOpenPopup()
				}
			},1000)
		},
		handleOpenViaInPadPopup(){
			const html = `
			<p class="pd-t-sm">${this.LANG.via_in_pad} : ${this.resolvedFileData.via_in_pad == 'Have' ? this.LANG.detected : this.LANG.none_detected}</p>
			<p class="pd-t-sm">${this.LANG.via_in_smd_pad} : ${this.resolvedFileData.via_on_smd_pad == 'Have' ? this.LANG.detected : this.LANG.none_detected}</p>
			<p class="pd-t-md">${this.LANG.have_via_pad_result_tip}</p>
			`
			const that = this
			this.$alert.confirm({
				title:this.LANG.tips,
				area:["550px"],
				content:html,
				btns:[{
					text: this.LANG.not_change,
					callBack(e){
						e.close()
					}
				},{
					text: this.LANG.change,
					callBack(e){
						that.params.cover = 'Non-Conductive Fill & Cap (VII)'
						e.close()
					}
				}],
				closeBtn: false,
				btnAlign:'right'
			})
		},
		// 点击减少拼版数量
		clickMinusNumber() {
			if(this.diableMinusPbnum){
				return false
			}
			this.params.pbnum --
			this.$store.commit("setQuoteParams",{value:this.params.pbnum,key:"pcb_params.pbnum"})
			this.countCalc();
		},
		// 点击增加拼版数量
		clickAddNumber() {
			if(this.diablePlusPbnum){
				return false
			}
			this.params.pbnum ++
			this.$store.commit("setQuoteParams",{value:this.params.pbnum,key:"pcb_params.pbnum"})
			this.countCalc();
		},
		// 显示下单须知弹窗
		showOrderKnow(e){
			let html = `
			<div class="public-order-know">
				<p>${this.LANG.pbnum_order_know1}</p>
				<p>${this.LANG.pbnum_order_know2}</p>
				<div class="demo-tip">
					<p>${this.LANG.pbnum_order_know2_1}</p>
					<p>${this.LANG.pbnum_order_know2_2}</p>
				</div>
				<p>${this.LANG.pbnum_order_know3}</p>
				<div class="img-list">
					<div class="img-item">
						<img src="${this.$imgList.pb1_img}">
						<p>${this.LANG.pbnum_img_desc1}</p>
					</div>
					<div class="img-item">
						<img src="${this.$imgList.pb2_img}">
						<p>${this.LANG.pbnum_img_desc3}</p>
					</div>
					<div class="img-item">
						<img src="${this.$imgList.pb3_img}">
						<p>${this.LANG.pbnum_img_desc5}</p>
					</div>
				</div>
				<p>${this.LANG.pbnum_order_know4}</p>
				<div class="img-list">
					<div class="img-item">
						<img src="${this.$imgList.pb4_img}">
						<p>${this.LANG.pbnum_img_desc2}</p>
					</div>
					<div class="img-item">
						<img src="${this.$imgList.pb5_img}">
						<p>${this.LANG.pbnum_img_desc3}</p>
					</div>
					<div class="img-item">
						<img src="${this.$imgList.pb6_img}">
						<p>${this.LANG.pbnum_img_desc5}</p>
					</div>
				</div>
			</div>
			`
			this.$alert.dialog({
					//position:"top",
					content: html,					
					show:true
				},e)
		},
		handleValidLen(e){
			const value = e.target.value
			if (value && (value.length < 5 || value.length > 1000)) {
				this.$alert.msg(this.LANG.note_len_tip)
				this.pcbNoteErr = true
			}
			else{
				this.pcbNoteErr = false
			}
		},
		handldeShowMore(type){
			this.showPart[type] = !this.showPart[type]
		},
		handlePcsCountCheck(checkObj){
			this.showPcsTip = checkObj.show
			this.pcsCountTip = checkObj.tip
		},
		roateMoreArrow(idx){
			return this.showPart[idx] ? 'roate-arrow' : 'roate-arrow1'
		},
		paramClick(name) {
			this.$set(this.isClick, name, true)
		},
		//提示数量未填写
		//如果选择0 美金
		// pcb_noteInput(e){
		// 	//限制输入
		// 	let firststr = this.$store.state.quote.pcbFirstTips,val = e.target.value;
		// 	if(this.pcb_note_first && val.indexOf(firststr + " ")<0){
		// 		this.params.pcb_note = firststr + " ";
		// 	}
		// }
		initPcbChangeParams(info) {
			for(let i in info) {
				// this.isClick[i] = true
				this.$set(this.isClick, i, true)
				// console.log(i,this.isClick[i])
			}
			let personalityArr = []
			console.log('initPcbChangeParams*/*/*/', this.isClick, info)
			for(let k in this.params) {
				this.params[k] = info[k]
				
				if (['bwidth', 'blength'].includes(k)) {
					this.params[k] = this.$tools.keepDecimal(Number(info[k]) * 10, 1)
				}

				if (['copper', 'insidecopper', 'vias', 'lineweight', 'report_type'].includes(k)) {
					this.params[k] = Number(info[k])
				}

				if (['bankong', 'baobian'].includes(k) && info[k] == 0) {
					this.params[k] = ''
				}
					//处理特殊工艺
				if(k == "blind" && info[k] > 0){
					this.specialprocess.push("blind");
					this.blind = 1
				}
				if(k=="impendance" && info[k] == 1){
					this.specialprocess.push("impendance");
				}
				if(k=="beveledge" && info[k] == 1){
					this.specialprocess.push("beveledge");
				}
				if(k=="bankong" && info[k] == 1 || k=="baobian" && info[k] == 1){
					this.specialprocess.push("bankong");
				}
				if(k=="via_in_pad" && info[k] == "Have"){
					this.specialprocess.push("via_in_pad");
				}
				//个性化服务
				// if(k == "review_file" && info[k] > 0){
				// 	this.personality.push("review_file");
				// 	this.isoldOdercout = true;
				// }
				if(k == "shipment_report" && info[k] > 0){					
					personalityArr.push("shipment_report");
				}
				if(k == "slice_report" && info[k] > 0){					
					personalityArr.push("slice_report");
				}
				if(k == 'film_report' && info[k] == 1){
					personalityArr.push('film_report')
				}
				// if(k == "has_period" && info[k] == 6){
				// 	this.personality.push("has_period");					
				// }
			}
			this.personality = personalityArr

			if(this.isFpc || this.isRfpc) {
				if(Number(this.params.reinforce_steel)) {
					this.fpc_stiffener.push('reinforce_steel')
				}

				if(Number(this.params.reinforce_aluminium)) {
					this.fpc_stiffener.push('reinforce_aluminium')
				}

				if(Number(this.params.reinforce_fr4)) {
					this.fpc_stiffener.push('reinforce_fr4')
				}

				if(Number(this.params.reinforce_pi)) {
					this.fpc_stiffener.push('reinforce_pi')
				}

				if(this.params.tape) {
					this.params.tape = 1
				} else {
					this.params.tape = 0
				} 

				if (this.params.fpc_forming !== 'Laser Forming') {
					this.fpc_forming_method = 'Mold Forming'
				}
			}

			if (this.isFpc) {
				this.params.blayer = info.fpc_blayer
			}

			if(this.params.has_period == 2) {
				this.params.period_format = 0
			}

			if (!this.params.board_tg) {
				this.params.board_tg = 'TG130'
			}

			console.log('initPcbChangeParams*/*/*/', this.params)
			this.getAnalyseOrderParams()
		},
		handleInputReinforceNum(value) {
      // 限制输入为0或正整数
      this.params.reinforce_num = value.replace(/[^0-9]/g, '')
      if (this.params.reinforce_num !== '' && parseInt(this.params.reinforce_num) === 0) {
        this.params.reinforce_num = 1
      }
    },
		plateTypeClick() {
			console.log('plateTypeClick', this.isClick)
			for(let i in this.isClick) {
				this.$set(this.isClick, i , false)
			}
		},
		// 根据文件路径获取分析ID
		getAnalyseIdByPath(uploadInfo) {
			return new Promise((resolve,reject)=>{
				const { fid, url, name } = uploadInfo
				const newUrl = process.env.VUE_APP_HOST + url
				this.$http
					.post(
						this.$api.uploadDfmFile,
						{ fid, url: newUrl, name },
					)
					.then((res) => {
						if (res.response_code === '2000') {
							resolve(res.response_data.analyse_id)
						}
						else {
							reject(null)
						}
					})
			}) 
		},
		// 获取新版dfm解析的文件参数
		async getAnalyseOrderParams() {
			const { fid, file_name, gerber_file} = this.changeParams
			const id = await this.getAnalyseIdByPath({fid, url: gerber_file, name:file_name })
      const params = { id }
		

      this.$http({ url: this.$api.orderParams, method: 'get', params })
        .then((res) => {
          const analyseOrderParams =  res.response_data.order_params

					// 锣长分析值
					let luo,luoNum = 0
					try {
						luo = analyseOrderParams.pcb_specs.find(item=>item.name==='锣长分析'||item.english_name.includes('Milling Density'))
						if(luo && luo.display) {
							const match =  luo.display.match(/(\d+(\.\d+)?)/)
							luoNum = match ? match[0] : 0
							this.resolvedFileData.luoNum = luoNum

							// const luocheng = Math.floor(this.area * (this.resolvedFileData?.luoNum || 0)) || 0
							// console.log('luocheng******',luoNum,luocheng)
							this.$store.commit("setQuoteParams",{value:luoNum,key:"pcb_params.luocheng"})
					
						}
					} catch(e) {
						console.log(e)
					}
        })
    },
		getRecommendStackup()	{
			if (!this.showRecommendStackup) {
				return false
			}
			this.recommendStackUp = []
			this.list.pressing = this.$options.data().list.pressing
			this.$tools.debounce(()=>{
				this.$http.post(this.$api.getRecommendStackUp, this.stackupParams).then(res => {
					if (res.status == 1) {
						const result = res.data.map(item => {
							return {
								word: 'NextPCB ' + item.press_no_and_pp,
								keys: item.press_no_and_pp,
								real: item.press_no_and_pp
							}
						})
						this.recommendStackUp = result

						if (this.recommendStackUp.length > 0) {
							this.list.pressing = [
								...this.$options.data().list.pressing,
								...this.recommendStackUp
							]

							const currentIsInList = this.list.pressing.find(
								item => item.real == this.params.pressing
							)
							if (!currentIsInList) {
								this.params.pressing = ''
							}
						}
					}
				})
			},"getRecommendStackup", 1000)();
		},
		openStackupDialog() {
			this.showStackUp = true
		},
		handleStackup(value) {
			this.params.pressing = value
		}
	},
	watch:{
		'$route.query'(v) {
			const { from, plate_type } = v
			console.log(v, this)
			if (from && from === 'entry') {
				this.params.plate_type = plate_type 
			}
		},
		changeParams: {
			handler(v) {
				if(this.isChangeParams) {
					this.getRecommendStackup()
					this.initPcbChangeParams(v)
				}
			},
			deep: true
		},
		"params.blind": function(v){
			this.countVias();
			this.countLineweight();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.blind"});
			
			// 获取推荐叠层
			this.getRecommendStackup()

			this.countCalc();
		},
		"params.plate_type": function(v){
			if (!this.isChangeParams && !this.isSetPageData) {
				for(let i in this.isClick) {
					this.$set(this.isClick, i , false)
				}
			}
			this.countBeveledge();
			this.countLayer();
			this.countBheight();
			this.countBlind();
			this.countBeveledge();
			this.countBankong();
			this.countVia_in_pad();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.plate_type"});
			
			this.countCopper()
			this.countLineweight()
			this.countVias()
			this.countMaskColor()
			this.countPersonalityNew()
			this.calcSize("blength","bwidth",true)
			this.countBcount()
			this.countSpray()
			this.countTest();
			this.countTg();

			this.params.period_format = 0
			// 板材改变，清空物流方式
			this.params.express = ''
			this.$store.commit('setaside_param', { key: 'express', value: '' })

			if (this.isFpc || this.isRfpc) {
				this.countFpcThickness()
				this.countFpcColor()
				this.countFpcCharcolor();
				
				(!this.isChangeParams && !this.isSetPageData) && (this.params.review_file = 2)
			}
			
			if (this.isAluminum || this.isCopper) {
				this.plateTypeChangeCount ++ 
				if (!this.changeParams  && !this.isSetPageData) {
					this.params.review_file = 2
					this.params.copper = 0.5
					this.params.vias = 1.0
				}
			} 
			if(v === 'Fr-4') {
				(!this.isChangeParams  && !this.isSetPageData) &&  (this.params.review_file = 0)
			}

			if (this.isRfpc || this.isRogers){
				this.countCharcolor();
			}


			if(this.isFr4) {
				this.$store.commit("setQuoteParams",{value:'',key:"pcb_params.invoice"})
			} else {
				this.$store.commit("setQuoteParams",{value:'增票全电',key:"pcb_params.invoice"})
			}
			
			//板材
			this.countCalc();
		},
		"params.blayer": function(v){
			if(this.params.bcount){
				this.bcountCheck = false;
			}
			// if(!this.pcsCountTip) {
			// 	this.showPcsTip = false
			// }
			this.countBcount()
			this.countBlind();
			this.countBheight();
			this.countTg();
			// this.countCopper();
			this.countInsidecopper();
			this.countLineweight();
			this.countVias();
			this.countTest();
			// this.countBankong()
			// this.countPlugInHoles()
			this.calcSize("blength","bwidth",true);
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.blayer"});
			// this.noAcceptParams()
			if (this.isFpc) {
				this.countFpcThickness()
				this.$store.commit("setQuoteParams",{value:v,key:"fpc_params.fpc_blayer"});
			}
			// 获取推荐叠层
			this.getRecommendStackup()
			//板层
			this.countCalc({fieldName: 'blayer'});
		},
		"params.board_tg": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.board_tg"});
			//board_tg
			this.countCalc();
		},
		"params.rogers": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.rogers"});
			//rogers
			this.countCalc();
		},
		"params.thermalc": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.thermalc"});
			//thermalc
			this.countCalc();
		},
		"params.bheight": function(v){
			// this.countBheight();
			// this.countCopper();
			this.countVias();
			// this.countBankong();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.bheight"});
			
			// 获取推荐叠层
			this.getRecommendStackup()

			//板子厚度
			this.countCalc({fieldName: 'bheight'});
			// this.noAcceptParams()
		},
		"params.color": function(v){
			this.countCharcolor();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.color"});
			//阻焊颜色
			this.countCalc({fieldName: 'color'});
			// this.noAcceptParams()
		},
		"params.charcolor": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.charcolor"});
			//字符颜色
			this.countCalc();
		},
		"params.copper": function(v){
			this.countBeveledge();
			//this.countImpendance();
			// this.countBankong();
			this.countVia_in_pad();
			this.countLineweight();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.copper"});
			
			// 获取推荐叠层
			this.getRecommendStackup()

			//铜箔厚度
			this.countCalc({fieldName: 'copper'});
			// this.noAcceptParams()
		},
		"params.insidecopper": function(v){
			this.countBeveledge();
			// this.countBankong();
			this.countVia_in_pad();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.insidecopper"});
			
			// 获取推荐叠层
			this.getRecommendStackup()
			
			//内层铜厚
			this.countCalc();
		},
		"params.lineweight": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.lineweight"});
			//最小线宽/线距
			this.countCalc();
		},
		"params.vias": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.vias"});
			// this.countPlugInHoles()
			//Min. Drilled Hole
			this.countCalc();
		},
		"params.cover": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.cover"});
			//阻焊覆盖
			this.countCalc();
		},
		"params.spray": function(v){
			//this.countBankong();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.spray"});
			//焊盘喷镀
			this.countCalc({fieldName: 'spray'});
			if(this.params.bwidth && this.params.blength){
				this.$tools.debounce(()=>{
					this.calcSize("blength","bwidth", true);
				},"bwidthCount",1000)();
			}
		},
		// 铝基板-插件孔
		"params.plug_in_holes": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.plug_in_holes"});
			this.countCalc();
		},
		"params.cjh": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.cjh"});
			//執行計價方法
			this.countCalc();
		},
		// 电金厚度
		"params.electrogilding_thickness": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"fpc_params.electrogilding_thickness"});
			if (this.isRogers) {
				this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.electrogilding_thickness"});
			}
			//執行計價方法
			this.countCalc();
		},
		"params.beveledge": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.beveledge"});
			//金手指斜边
			this.countCalc();
		},
		"params.impendance": function(v){
			// this.countCopper();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.impendance"});
			//阻抗
			this.countCalc();
		},
		"params.via_in_pad": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.via_in_pad"});
			//執行計價方法
			this.countCalc();
		},
		//测试点数
		"params.testpoint": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.testpoint"});
			this.countCalc();
		},
		//沉金面积
		"params.cjarea": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.cjarea"});
			this.countCalc();
		},
		"params.test": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.test"});
			//飞针测试
			this.countCalc();
		},
		"params.zknum": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.zknum"});
			//半孔/孔密度
			this.countCalc();
		},
		"params.shipment_report": function(v){			
			this.$store.commit("setQuoteParams",{value:v?1:0,key:"pcb_params.shipment_report"});
			this.countCalc();
		},
		"params.report_type": function(v){
			this.$store.commit("setQuoteParams",{value:v?v:0,key:"pcb_params.report_type"});
			this.countCalc();
		},
		"params.slice_report": function(v){			
			this.$store.commit("setQuoteParams",{value:v?1:0,key:"pcb_params.slice_report"});
			this.countCalc();
		},
		"params.period_format": function(v){
			let newVal = 2
			if(v == 0){
				newVal = 2
				this.$store.commit("setQuoteParams",{value:2,key:"pcb_params.has_period"});
			}
			else{
				newVal = v
				this.$store.commit("setQuoteParams",{value:6,key:"pcb_params.has_period"});
			}
			this.$store.commit("setQuoteParams",{value:newVal,key:"pcb_params.period_format"});
			//ul marlk
			this.countCalc();
		},
		"params.has_period": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.has_period"});
			//ul marlk
			this.countCalc();
		},
		// 实物菲林
		"params.film_report": function(v){
			this.$store.commit("setQuoteParams",{value:v || 0,key:"pcb_params.film_report"});
			this.countCalc();
		},
		"params.review_file": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.review_file"});
			//Working Gerber
			this.countCalc();
		},
		"params.bankong": function(v){
			this.isFr4 && this.countSpray();
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.bankong"});
			//Working Gerber
			this.countCalc();
		},
		"params.baobian": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.baobian"});
			this.countCalc();
		},
		"params.pressing": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.pressing"});
			//Working Gerber
			this.countCalc();
		},
		"params.fid": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.fid"});
		},
		"params.pcbParsingFile": {
			deep: true,
			handler(v){				
				this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.pcbParsingFile"});	
			}
		},
		//个性化服务多选
		"personality": function(v){
			this.countPersonality(v);
		},
		"notCheckReport"(v){
			if(v.length) {
				this.personality.length && (this.personality = [])
			}

			this.$nextTick(() => {
				if (!v.length && !this.personality.length) {
					this.notCheckReport = ['not_required']
				}
			})
		},
		//特殊工艺
		"specialprocess": function(v){
			// this.countSpecialprocess(v);
		},
		//打叉板
		"params.cross_board": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.cross_board"});
			this.countCalc();
		},
		"params.pcb_note": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.pcb_note"});
		},
		"params.eq_mode": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.eq_mode"});
			this.$store.commit("setParamsCheck",{ value: false, key:"eqModeTipShow"});
		},
		"params.acceptance": function(v){
			this.$store.commit("setQuoteParams",{value:v,key:"pcb_params.acceptance"});
			this.countCalc();
		},
		resolvedFileData:{
			handler(newVal){
				// if((newVal.via_in_pad == 'Have' || newVal.via_on_smd_pad == 'Have') && newVal.blayer > 2 ){
				// 	this.watchOpenPopup()
				// }
				this.countBoardType()
			},
			deep: true
		},
		// 拼板款数
		'params.pbnum'(v){
			this.$store.commit("setQuoteParams",{value:v, key:"pcb_params.pbnum"})
			this.countBoardTypeByPbnum()
		},
		blind(v){
			this.handleBlindChange()
		},
		sizeTip(v){
			this.$store.commit("setParamsCheck",{ value: v, key:"sizeTip"});
		},
		pcsCountTip(v){
			this.$store.commit("setParamsCheck",{ value: v, key:"pcsCountTip"});
		},
		"params.pad_width"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"pcb_params.pad_width"})
		},
		"params.fpc_thickness"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_thickness"})
			this.countCalc()
		},
		"params.fpc_cover"(v) {
			this.countFpcColor()
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_cover"})
			this.countCalc()
		},
		"params.fpc_color"(v) {
			this.countFpcCharcolor()
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_color"})
			this.countCalc()
		},
		"params.fpc_charcolor"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_charcolor"})
			// this.countCalc()
		},
		"params.fpc_material"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_material"})
			this.countCalc()
		},
		"params.fpc_pi_thickness"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_pi_thickness"})
			this.countCalc()
		},
		"params.fpc_outsidecopper"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_outsidecopper"})
			this.countCalc()
		},
		"params.fpc_insidecopper"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_insidecopper"})
			this.countCalc()
		},
		fpc_forming_method(v) {
			if(v !=  'Laser Forming') {
				(!this.isChangeParams || !this.isSetPageData || this.params.fpc_forming == 'Laser Forming') && (this.params.fpc_forming = 'Regular Punching')
			} else {
				this.params.fpc_forming = 'Laser Forming'
				this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_forming"})
			}
		},
		"params.fpc_forming"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_forming"})
			this.countCalc()
		},
		"not_check_fpc_stiffener"(v) {
			if (v.length) {
				this.fpc_stiffener.length && (this.fpc_stiffener = [])
				this.params.reinforce_num = 0
			}
			this.$nextTick(() => {
				if (!v.length && !this.fpc_stiffener.length) {
					this.not_check_fpc_stiffener = ['not_required']
				}
			})
		},
		'fpc_stiffener':{
			handler(v) {
				if (v.length) {
					this.not_check_fpc_stiffener.length && (this.not_check_fpc_stiffener = [])
					if (!this.params.reinforce_num) {
						this.params.reinforce_num = 1
					}
					
				} else {
					this.not_check_fpc_stiffener = ['not_required']
				}
				this.countFpcStiffener()
			},
			deep:true
		},
		"params.reinforce_num"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.reinforce_num"})
			this.countCalc()
		},
		"params.reinforce_steel"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.reinforce_steel"})
			this.countCalc()
		},
		"params.steel_thickness"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.steel_thickness"})
			this.countCalc()
		},
		"params.reinforce_aluminium"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.reinforce_aluminium"})
			this.countCalc()
		},
		"params.aluminium_thickness"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.aluminium_thickness"})
			this.countCalc()
		},
		"params.reinforce_fr4"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.reinforce_fr4"})
			this.countCalc()
		},
		"params.fr4_thickness"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fr4_thickness"})
			this.countCalc()
		},
		"params.reinforce_pi"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.reinforce_pi"})
			this.countCalc()
		},
		"params.pi_thickness"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.pi_thickness"})
			this.countCalc()
		},
		"params.tape"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.tape"})
			this.countCalc()
		},
		"params.emi"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.emi"})
			this.countCalc()
		},
		"params.condresin"(v) {
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.condresin"})
			this.countCalc()
		},
		"params.fpc_blayer"(v) {
			this.countFpcThickness()
			this.$store.commit("setQuoteParams",{value:v, key:"fpc_params.fpc_blayer"})
			this.countCalc()
		}
	},
	components: {
		'pcb-upgerberfile':pcbUpgerberfile,
		'quote-check':quotecheck,
		'src-select':srcselect,
		'check-quantity':checkQuantity,
		'np-input':input,
		"quote-relation":quoteRelation,
		'np-collapse':npCollapse,
		StackUpDialog
		//checkbox
	}
}
</script>
<style lang="scss" scoped>
	.p_top_0{
		padding-top: 0;
	}
	.number-input-box {
		width: 122px;
		height: 34px;
		border: 1px solid #C00;
		border-radius: 3px;
		box-sizing: border-box;
		display: inline-flex;
		.input-box {
			width: 54px;
			height: 100%;
			border-left: 1px solid #c00;
			border-right: 1px solid #c00;
			border-top: none;
			border-bottom: none;
			box-sizing: border-box;
			background: rgba(0,0,0,0.00);
			padding: 0 10px;
			text-align: center;
		}
		.number-input-btn{
			width: 34px;
			height: 32px;
			background: #c00;
			color: #FFF;
			font-weight: 700;
			font-size: 16px;
			// border-radius: 3px 0px 0px 3px;
			display: flex;
			justify-content: center;
			// align-items: center;
			cursor: pointer;
			user-select: none;

			img {
				user-select: none;
			}
		}

		.minus{
			line-height: 29px;
		}

		.plus {
			font-size: 28px;
			line-height: 26px;
		}
	}

	.flex-cell{
		display: flex;
		align-items: center;

		p {
			padding-left: 10px;
		}
	}

	.under-line{
		text-decoration: underline;
	}

	.disable {
		cursor: not-allowed !important;
	}

	.title-bar{
		width: 100%;
		height: 36px;
		background: #f8f8f8;
		border-radius: 4px;
		box-sizing: border-box;
		padding: 0 10px 0 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		// margin-bottom: 10px;

		h2 {
			font-size: 16px;
			font-weight: 700;
		}

		.show-more{
			padding: 10px;
			display: flex;
			align-items: center;
			cursor: pointer;
			color: #999;
			&:hover{
				.icon-arrow {
					.main {
						fill: #7a7a7a;
					}
				}
			
			}

			.icon-arrow {
				.bg {
					fill: none;
				}

				.main {
					fill: #c7c6c6;
				}
			}
		}
	}

	.params-box{
		padding: 20px;
	}

	.roate-arrow{
		transform: rotate(180deg);
		transition: all 0.3s;
	}
	.roate-arrow1{
		transform: rotate(0deg);
		transition: all 0.3s;
	}

	.a_hover {
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
</style>

<style lang="scss">
.public-order-know{
	width: 670px;
	font-size: 12px;
	line-height: 18px;

	p {
		padding: 0;
		margin: 0;
		margin-bottom: 10px;
	}
	
	.demo-tip{
		width: 100%;
		padding: 10px;
		background: #fff7ec;
		border-radius: 4px;
		box-sizing: border-box;
		color: #b8802c;
		line-height: 16px;
		margin-bottom: 10px;

		p{
			margin-bottom: 0;
		}
	}

	.img-list{
		display: flex;
		justify-content: space-between;
		
		.img-item{
			flex: 1;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			p {
				font-size: 12px;
				color: #999;
				white-space: nowrap;
				line-height: 16px;
				margin-top: 4px;
			}
		}
	}
}

.pcb-plate-type{
	.quotecheck{
		.quotecheck-text{
			display: flex;
			align-items: center;
		}
	}
}

.np-input_err{
	.quotecheck-text {
		border: 1px solid #C00 !important;
	}
}
</style>